import TeacherHome from './TeacherHome';
import ChangePassword from './ChangePassword';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Calendar from './Calendar';
import AttendanceCalendar from './AttendanceCalendar';

import MarksheetTemplateManager from './MarksheetTemplateManager';
import TemplateBasedMarksheetEntry from './TemplateBasedMarksheetEntry';
import WhatsAppMessenger from './WhatsAppMessenger';
import EnhancedTeacherDiary from './EnhancedTeacherDiary';
import StudentDeviceMonitor from './StudentDeviceMonitor';
import DailyAttendanceView from './DailyAttendanceView';
import AttendanceMaster from './AttendanceMaster/AttendanceMaster';
import QuickMarkDashboard from './AttendanceMaster/QuickMarkDashboard';
import TeacherUnifiedDesk from './TeacherUnifiedDesk';
import ClassAnalyticsDashboard from './ClassAnalyticsDashboard';
import MyComplianceCard from './bi/MyComplianceCard.jsx';
import StudentBehaviorRadarChart from './StudentBehaviorRadarChart';
import StudentBehaviorDisplay from './StudentBehaviorDisplay';
import EnhancedTeacherAttendanceView from './EnhancedTeacherAttendanceView';
import TimetableManager from './TimetableManager';
import GamesManager from './Games/GamesManager';
import PrintableMarksheet from './PrintableMarksheet';
import QuestionPaperBuilder from './QuestionPaperBuilder/QuestionPaperBuilder';
import ProfessionalMarksheet from './ProfessionalMarksheet';
import { formatDateWithWeekdayIST, parseFromDatabase, getCurrentDateIST } from '../utils/timezone';
import JoinLiveClassButton from './LiveStream/JoinLiveClassButton';
import './TeacherDashboard.css';

import { API_BASE_URL } from '../config/api';

// Add CSS for navigation scrollbar hiding
const navStyle = document.createElement('style');
navStyle.textContent = `
  .nav-scroll::-webkit-scrollbar {
    display: none;
  }
`;
if (!document.head.querySelector('style[data-nav-scroll]')) {
  navStyle.setAttribute('data-nav-scroll', 'true');
  document.head.appendChild(navStyle);
}

function TeacherDashboard({ user, onLogout, isTeacherAdmin = false, onImpersonate, isImpersonating = false, onStopImpersonation, originalUser, isPrincipalImpersonating = false }) {
  // Debug: Log the API base URL
  console.log('API_BASE_URL:', API_BASE_URL);
  
  const [students, setStudents] = useState([]);
  const [newContent, setNewContent] = useState({ title: '', description: '', type: 'note' });
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [showProfile, setShowProfile] = useState(false);
  const [onlineContent, setOnlineContent] = useState({ title: '', description: '', subject: '', resourceLink: '', linkType: 'youtube' });
  const [courseLink, setCourseLink] = useState({ title: '', description: '', resourceLink: '', linkType: 'video' });
  const [assignments, setAssignments] = useState([]);
  const [existingOnlineContent, setExistingOnlineContent] = useState([]);
  const [existingCourseLinks, setExistingCourseLinks] = useState([]);
  const [showLibraryModal, setShowLibraryModal] = useState(false);
  const [libraryLink, setLibraryLink] = useState({ title: '', resourceLink: '', description: '' });
  const [libraryLinks, setLibraryLinks] = useState([]);
  const [showMarksheetModal, setShowMarksheetModal] = useState(false);
  const [marksheetData, setMarksheetData] = useState({});
  const [showIdCardModal, setShowIdCardModal] = useState(false);
  const [idCardData, setIdCardData] = useState({});
  const [classworkData, setClassworkData] = useState([]);
  const [showClassworkModal, setShowClassworkModal] = useState(false);
  const [newClasswork, setNewClasswork] = useState({ date: '', type: 'classwork', subject: '', message: '' });
  const [showAllStudents, setShowAllStudents] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editedStudent, setEditedStudent] = useState({});
  const [showCalendar, setShowCalendar] = useState(false);
  const [myAttendance, setMyAttendance] = useState([]);
  const [showMyAttendance, setShowMyAttendance] = useState(false);
  const [myRanking, setMyRanking] = useState(null);
  const [showRanking, setShowRanking] = useState(false);
  const [showTemplateManager, setShowTemplateManager] = useState(false);
  const [showTemplateBasedMarksheet, setShowTemplateBasedMarksheet] = useState(false);
  const [marksheetTemplate, setMarksheetTemplate] = useState(null);
  const [showWhatsAppMessenger, setShowWhatsAppMessenger] = useState(false);
  const [selectedStudentForWhatsApp, setSelectedStudentForWhatsApp] = useState(null);
  const [showEnhancedDiary, setShowEnhancedDiary] = useState(false);
  const [diaryFullView, setDiaryFullView] = useState(false);
  const [showDiaryPopup, setShowDiaryPopup] = useState(false);
  const [attendanceVisibility, setAttendanceVisibility] = useState(true);
  const [showDeviceMonitor, setShowDeviceMonitor] = useState(false);
  const [showDailyAttendance, setShowDailyAttendance] = useState(false);
  const [selectedAttendanceDate, setSelectedAttendanceDate] = useState(null);
  const [showBehaviorChart, setShowBehaviorChart] = useState(false);
  const [selectedStudentForBehavior, setSelectedStudentForBehavior] = useState(null);
  const [showMyAttendanceView, setShowMyAttendanceView] = useState(false);
  const [showEnhancedAttendanceView, setShowEnhancedAttendanceView] = useState(false);
  const [showTimetableManager, setShowTimetableManager] = useState(false);
  const [showIdCard, setShowIdCard] = useState(false);
  const [showPrintableMarksheet, setShowPrintableMarksheet] = useState(false);
  const [showProfessionalMarksheet, setShowProfessionalMarksheet] = useState(false);

  const [allTeachers, setAllTeachers] = useState([]);
  const [showTeacherList, setShowTeacherList] = useState(false);
  const [dynamicSubjects, setDynamicSubjects] = useState([]);

  const [activeSection, setActiveSection] = useState('attendance');
  const [showHome, setShowHome] = useState(true);
  const [showChangePassword, setShowChangePassword] = useState(false);



  useEffect(() => {
    fetchStudents();
    fetchAssignments();
    fetchExistingOnlineContent();
    fetchExistingCourseLinks();
    fetchLibraryLinks();
    fetchClasswork();
    fetchMyAttendance();
    fetchMyRanking();
    fetchMarksheetTemplate(user.class);
    loadDynamicSubjects();
    fetchAttendanceVisibility();
    if (isTeacherAdmin) {
      fetchAllTeachers();
    }
    console.log('User object:', user);
  }, []);

  useEffect(() => {
    if (marksheetTemplate) {
      initializeMarksheetData();
    }
  }, [marksheetTemplate]);

  useEffect(() => {
    if (dynamicSubjects.length > 0) {
      setOnlineContent(prev => ({ ...prev, subject: prev.subject || dynamicSubjects[0] }));
      setNewClasswork(prev => ({ ...prev, subject: prev.subject || dynamicSubjects[0] }));
    }
  }, [dynamicSubjects]);

  const fetchMyAttendance = async () => {
    try {
      const currentMonth = new Date().getMonth() + 1;
      const currentYear = new Date().getFullYear();
      const response = await axios.get(`${API_BASE_URL}/api/teacher-attendance/${user.id}?month=${currentMonth}&year=${currentYear}`);
      setMyAttendance(response.data || []);
    } catch (error) {
      console.error('Error fetching my attendance:', error);
      setMyAttendance([]);
    }
  };

  const fetchMyRanking = async () => {
    try {
      const currentMonth = new Date().getMonth() + 1;
      const currentYear = new Date().getFullYear();
      const response = await axios.get(`${API_BASE_URL}/api/teacher-ranking/${user.id}?month=${currentMonth}&year=${currentYear}`);
      setMyRanking(response.data);
    } catch (error) {
      console.error('Error fetching my ranking:', error);
      setMyRanking(null);
    }
  };

  const getAttendanceStats = () => {
    const attendanceArray = myAttendance || [];
    const totalDays = attendanceArray.length;
    const presentDays = attendanceArray.filter(att => att.status === 'present').length;
    const absentDays = attendanceArray.filter(att => att.status === 'absent').length;
    const lateDays = attendanceArray.filter(att => att.status === 'late').length;
    const percentage = totalDays > 0 ? ((presentDays + lateDays) / totalDays * 100).toFixed(1) : 0;
    return { totalDays, presentDays, absentDays, lateDays, percentage };
  };

  // Body scroll lock for mobile popups (Calendar handles its own scroll lock)
  useEffect(() => {
    if (showProfile || showLibraryModal || showMarksheetModal || showIdCardModal || showClassworkModal || showWhatsAppMessenger || showDiaryPopup) {
      // Prevent background scrolling
      document.body.classList.add('popup-open');
      // Store current scroll position
      const scrollY = window.scrollY;
      document.body.style.top = `-${scrollY}px`;
    } else {
      // Restore scroll position
      const scrollY = document.body.style.top;
      document.body.classList.remove('popup-open');
      document.body.style.top = '';
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      }
    }
    return () => {
      document.body.classList.remove('popup-open');
      document.body.style.top = '';
    };
  }, [showProfile, showLibraryModal, showMarksheetModal, showIdCardModal, showClassworkModal, showWhatsAppMessenger, showDiaryPopup]);

  const fetchAssignments = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/content/${user.class}`);
      const assignmentData = response.data.filter(content => content.type === 'assignment');
      setAssignments(assignmentData);
    } catch (error) {
      console.error('Error fetching assignments:', error);
    }
  };

  const fetchExistingOnlineContent = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/online-content/${user.class}`);
      setExistingOnlineContent(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error('Error fetching online content:', error);
      setExistingOnlineContent([]);
    }
  };

  const fetchExistingCourseLinks = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/course-links/${user.class}`);
      setExistingCourseLinks(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error('Error fetching course links:', error);
      setExistingCourseLinks([]);
    }
  };



  const fetchStudents = async () => {
    try {
      console.log('Fetching students from:', `${API_BASE_URL}/api/users`);
      const response = await axios.get(`${API_BASE_URL}/api/users`);
      setStudents(response.data.filter(u => u.role === 'student' && u.class === user.class));
    } catch (error) {
      console.error('Error fetching students:', error);
    }
  };

  const fetchAllTeachers = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/users`);
      setAllTeachers(response.data.filter(u => u.role === 'teacher'));
    } catch (error) {
      console.error('Error fetching teachers:', error);
    }
  };

  const handleContentUpload = async (e) => {
    e.preventDefault();
    const fileInput = document.querySelector('input[type="file"]');
    const file = fileInput?.files[0];
    
    // Check file size before upload
    if (file && file.size > 1024 * 1024) { // 1MB in bytes
      alert('File size exceeds 1MB limit. Please choose a smaller file.');
      fileInput.value = ''; // Clear the input
      return;
    }
    
    const formData = new FormData();
    formData.append('title', newContent.title);
    formData.append('description', newContent.description);
    formData.append('type', newContent.type);
    formData.append('class', user.class);
    formData.append('uploadedBy', user.id);
    formData.append('uploaderRole', user.role);
    
    if (file) {
      formData.append('file', file);
    }
    
    try {
      await axios.post(`${API_BASE_URL}/api/content`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setNewContent({ title: '', description: '', type: 'note' });
      if (fileInput) fileInput.value = '';
      alert('Content uploaded successfully!');
    } catch (error) {
      console.error('Error uploading content:', error);
      const errorMessage = error.response?.data?.message || error.message;
      if (errorMessage.includes('1MB') || errorMessage.includes('file size')) {
        alert('File size exceeds 1MB limit. Please choose a smaller file.');
      } else {
        alert('Error uploading content: ' + errorMessage);
      }
      if (fileInput) fileInput.value = ''; // Clear the input on error
    }
  };

  const markAttendance = async (studentId, status) => {
    try {
      await axios.post(`${API_BASE_URL}/api/attendance`, {
        student: studentId,
        date: new Date(),
        status: status,
        class: user.class
      });
      alert(`Attendance marked as ${status}!`);
    } catch (error) {
      console.error('Error marking attendance:', error);
    }
  };

  const postAnnouncement = async () => {
    const textarea = document.querySelector('#announcement-textarea');
    if (textarea && textarea.value.trim()) {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/announcements`, {
          message: textarea.value,
          type: 'class',
          class: user.class || '10A',
          createdBy: user.name || 'Teacher'
        });
        console.log('Announcement posted:', response.data);
        alert(`Class announcement posted successfully!`);
        textarea.value = '';
      } catch (error) {
        console.error('Error posting announcement:', error);
        alert('Error posting announcement');
      }
    } else {
      alert('Please write an announcement first');
    }
  };

  const createAssignment = async () => {
    const title = prompt('Assignment Title:');
    const description = prompt('Assignment Description:');
    const dueDate = prompt('Due Date (YYYY-MM-DD):');
    if (title && description && dueDate) {
      try {
        await axios.post(`${API_BASE_URL}/api/content`, {
          title: title,
          description: `${description} - Due: ${dueDate}`,
          type: 'assignment',
          class: user.class,
          uploadedBy: user.id
        });
        alert(`Assignment "${title}" created successfully!`);
        fetchAssignments();
      } catch (error) {
        console.error('Error creating assignment:', error);
        alert('Error creating assignment');
      }
    }
  };

  const deleteAssignment = async (assignmentId) => {
    if (window.confirm('Are you sure you want to delete this assignment?')) {
      try {
        await axios.delete(`${API_BASE_URL}/api/content/${assignmentId}`);
        alert('Assignment deleted successfully!');
        fetchAssignments();
      } catch (error) {
        console.error('Error deleting assignment:', error);
        alert('Error deleting assignment');
      }
    }
  };

  const editAssignment = async (assignment) => {
    const newTitle = prompt('Edit Assignment Title:', assignment.title);
    const newDescription = prompt('Edit Assignment Description:', assignment.description);
    if (newTitle && newDescription) {
      try {
        await axios.put(`${API_BASE_URL}/api/content/${assignment._id}`, {
          title: newTitle,
          description: newDescription
        });
        alert('Assignment updated successfully!');
        fetchAssignments();
      } catch (error) {
        console.error('Error updating assignment:', error);
        alert('Error updating assignment');
      }
    }
  };

  const reviewSubmissions = () => {
    alert('Opening assignment submissions for review...');
  };

  const viewProgress = () => {
    alert('Detailed student progress report generated!');
  };

  const viewSchedule = () => {
    alert('Full class schedule displayed!');
  };

  const viewAnalytics = () => {
    alert('Detailed class analytics opened!');
  };

  const viewStudentProfile = (student) => {
    setSelectedStudent(student);
    setEditedStudent({
      ...student,
      // Academic Performance
      overallGrade: student.overallGrade || 'B+ (85%)',
      mathGrade: student.mathGrade || '88% (A-)',
      scienceGrade: student.scienceGrade || '82% (B+)',
      englishGrade: student.englishGrade || '85% (B+)',
      // Attendance
      totalDays: student.totalDays || '180',
      presentDays: student.presentDays || '165',
      absentDays: student.absentDays || '12',
      lateDays: student.lateDays || '3',
      // Discipline
      behaviorScore: student.behaviorScore || '95/100',
      warnings: student.warnings || '1',
      violations: student.violations || '0',
      commendations: student.commendations || '3',
      // Assignments
      completedAssignments: student.completedAssignments || '28/30 (93%)',
      onTimeSubmissions: student.onTimeSubmissions || '26/28 (93%)',
      lateSubmissions: student.lateSubmissions || '2',
      missingAssignments: student.missingAssignments || '2',
      // Parent Contact
      guardianName: student.guardianName || 'Mr. & Mrs. Parent',
      guardianPhone: student.guardianPhone || '+1-234-567-8900',
      guardianEmail: student.guardianEmail || 'parent@email.com',
      lastContact: student.lastContact || 'March 10, 2024'
    });
    setEditMode(false);
    setShowProfile(true);
  };

  const closeProfile = () => {
    setShowProfile(false);
    setSelectedStudent(null);
    setEditMode(false);
    setEditedStudent({});
  };
  
  const saveStudentProfile = async () => {
    try {
      // Never send password/_id/__v back; teachers edit profile data only
      const { password, _id, __v, createdAt, role, ...payload } = editedStudent;
      const res = await axios.put(`${API_BASE_URL}/api/users/${selectedStudent._id}`, payload);
      const saved = res.data && res.data._id ? res.data : { ...selectedStudent, ...payload };
      setSelectedStudent(saved);
      setEditedStudent({ ...saved });
      setEditMode(false);
      fetchStudents();
      alert('Student profile updated successfully!');
    } catch (error) {
      console.error('Error updating student:', error);
      alert('Error updating student profile');
    }
  };

  const handleOnlineContentSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API_BASE_URL}/api/online-content`, {
        title: onlineContent.title,
        description: onlineContent.description || '',
        subject: onlineContent.subject,
        resourceLink: onlineContent.resourceLink,
        linkType: onlineContent.linkType,
        class: user.class || '10A',
        uploadedBy: user.name || 'Teacher'
      });
      console.log('Online content added:', response.data);
      setOnlineContent({ title: '', description: '', subject: 'Hindi', resourceLink: '', linkType: 'youtube' });
      fetchExistingOnlineContent();
      alert('Online content added successfully!');
    } catch (error) {
      console.error('Error adding online content:', error);
      alert('Error adding online content: ' + (error.response?.data?.message || error.message));
    }
  };

  const handleCourseLinkSubmit = async (e) => {
    e.preventDefault();
    if (courseLink.title === 'Complete Course') {
      alert('Please use a different title. "Complete Course" is reserved for the main course link.');
      return;
    }
    try {
      const response = await axios.post(`${API_BASE_URL}/api/course-links`, {
        title: courseLink.title,
        description: courseLink.description || '',
        resourceLink: courseLink.resourceLink,
        linkType: courseLink.linkType,
        class: user.class || '10A',
        uploadedBy: user.name || 'Teacher'
      });
      console.log('Course link added:', response.data);
      setCourseLink({ title: '', description: '', resourceLink: '', linkType: 'video' });
      fetchExistingCourseLinks();
      alert('Additional course link added successfully!');
    } catch (error) {
      console.error('Error adding course link:', error);
      alert('Error adding course link: ' + (error.response?.data?.message || error.message));
    }
  };

  const editOnlineContent = async (content) => {
    const newTitle = prompt('Edit Title:', content.title);
    const newDescription = prompt('Edit Description:', content.description);
    const newResourceLink = prompt('Edit Resource Link:', content.resourceLink);
    if (newTitle && newResourceLink) {
      try {
        await axios.put(`${API_BASE_URL}/api/online-content/${content._id}`, {
          title: newTitle,
          description: newDescription || '',
          resourceLink: newResourceLink
        });
        fetchExistingOnlineContent();
        alert('Online content updated successfully!');
      } catch (error) {
        console.error('Error updating online content:', error);
        alert('Error updating online content');
      }
    }
  };

  const deleteOnlineContent = async (contentId) => {
    if (window.confirm('Are you sure you want to delete this online content?')) {
      try {
        await axios.delete(`${API_BASE_URL}/api/online-content/${contentId}`);
        fetchExistingOnlineContent();
        alert('Online content deleted successfully!');
      } catch (error) {
        console.error('Error deleting online content:', error);
        alert('Error deleting online content');
      }
    }
  };

  const editCourseLink = async (link) => {
    const newTitle = prompt('Edit Title:', link.title);
    const newDescription = prompt('Edit Description:', link.description || '');
    const newResourceLink = prompt('Edit Resource Link:', link.resourceLink);
    if (newTitle && newResourceLink) {
      try {
        console.log('Updating course link:', link._id);
        const response = await axios.put(`${API_BASE_URL}/api/course-links/${link._id}`, {
          title: newTitle,
          description: newDescription || '',
          resourceLink: newResourceLink
        });
        console.log('Update response:', response.data);
        fetchExistingCourseLinks();
        alert('Course link updated successfully!');
      } catch (error) {
        console.error('Error updating course link:', error);
        console.error('Error response:', error.response?.data);
        alert('Error updating course link: ' + (error.response?.data?.message || error.message));
      }
    }
  };

  const deleteCourseLink = async (linkId) => {
    if (window.confirm('Are you sure you want to delete this course link?')) {
      try {
        await axios.delete(`${API_BASE_URL}/api/course-links/${linkId}`);
        fetchExistingCourseLinks();
        alert('Course link deleted successfully!');
      } catch (error) {
        console.error('Error deleting course link:', error);
        alert('Error deleting course link');
      }
    }
  };

  const fetchLibraryLinks = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/course-links/${user.class}`);
      setLibraryLinks(response.data.filter(link => link.uploadedBy === user.name));
    } catch (error) {
      console.error('Error fetching library links:', error);
    }
  };

  const handleLibrarySubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_BASE_URL}/api/course-links`, {
        title: libraryLink.title,
        description: libraryLink.description || '',
        resourceLink: libraryLink.resourceLink,
        linkType: 'other',
        class: user.class,
        uploadedBy: user.name || 'Teacher'
      });
      setLibraryLink({ title: '', resourceLink: '', description: '' });
      setShowLibraryModal(false);
      fetchLibraryLinks();
      alert('Library resource added successfully!');
    } catch (error) {
      console.error('Error adding library resource:', error);
      alert('Error adding library resource: ' + (error.response?.data?.message || error.message));
    }
  };

  const editLibraryLink = async (link) => {
    const newTitle = prompt('Edit Title:', link.title);
    const newDescription = prompt('Edit Description:', link.description || '');
    const newResourceLink = prompt('Edit Resource Link:', link.resourceLink);
    if (newTitle && newResourceLink) {
      try {
        await axios.put(`${API_BASE_URL}/api/course-links/${link._id}`, {
          title: newTitle,
          description: newDescription || '',
          resourceLink: newResourceLink
        });
        fetchLibraryLinks();
        alert('Library link updated successfully!');
      } catch (error) {
        console.error('Error updating library link:', error);
        alert('Error updating library link: ' + (error.response?.data?.message || error.message));
      }
    }
  };

  const deleteLibraryLink = async (linkId) => {
    if (window.confirm('Are you sure you want to delete this library link?')) {
      try {
        await axios.delete(`${API_BASE_URL}/api/course-links/${linkId}`);
        fetchLibraryLinks();
        alert('Library link deleted successfully!');
      } catch (error) {
        console.error('Error deleting library link:', error);
        alert('Error deleting library link');
      }
    }
  };

  // Fetch marksheet template for the class
  const fetchMarksheetTemplate = async (className) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/marksheet-template/${className}`);
      setMarksheetTemplate(response.data);
    } catch (error) {
      console.error('No template found, using default:', error);
      // Fallback to default template
      setMarksheetTemplate({
        subjects: [
          { name: 'hindi', displayName: 'Hindi' },
          { name: 'english', displayName: 'English' },
          { name: 'maths', displayName: 'Mathematics' },
          { name: 'evs', displayName: 'EVS' },
          { name: 'gk', displayName: 'GK' },
          { name: 'computer', displayName: 'Computer' }
        ],
        examStructure: {
          term1: { enabled: true, maxMarks: 10 },
          term2: { enabled: true, maxMarks: 10 },
          halfYearly: { enabled: true, maxMarks: 80 },
          term3: { enabled: true, maxMarks: 10 },
          project: { enabled: true, maxMarks: 10 },
          annualExam: { enabled: true, maxMarks: 80 }
        }
      });
    }
  };

  // Get subjects based on template
  const getSubjectsForClass = () => {
    return marksheetTemplate?.subjects?.map(s => s.name) || [];
  };

  // Get subject display name from template
  const getSubjectDisplayName = (subject) => {
    const subjectObj = marksheetTemplate?.subjects?.find(s => s.name === subject);
    return subjectObj?.displayName || subject;
  };

  const initializeMarksheetData = () => {
    if (!marksheetTemplate) return;
    
    const subjects = getSubjectsForClass();
    const emptyExam = {
      drawing: '',
      discipline: '',
      neatness: '',
      parentsAttainedPTM: false
    };
    
    // Add all subjects to empty exam
    subjects.forEach(subject => {
      emptyExam[subject] = '';
    });
    
    const visibility = {};
    Object.entries(marksheetTemplate?.examStructure || {}).forEach(([exam, config]) => {
      visibility[exam] = config.enabled;
    });
    visibility.finalResult = false;
    
    setMarksheetData({
      term1: {...emptyExam},
      term2: {...emptyExam},
      halfYearly: {...emptyExam},
      term3: {...emptyExam},
      project: {...emptyExam},
      annualExam: {...emptyExam, attendance: ''},
      visibility
    });
  };

  const openMarksheetModal = async (student) => {
    try {
      // Check if template exists for this class
      const templateCheck = await axios.get(`${API_BASE_URL}/api/marksheet-template-exists/${student.class}`);
      if (!templateCheck.data.exists) {
        alert(`No marksheet template found for class ${student.class}. Please contact Admin Level 1 to create a marksheet pattern first.`);
        return;
      }
      
      setSelectedStudent(student);
      setShowTemplateBasedMarksheet(true);
    } catch (error) {
      console.error('Error checking template:', error);
      alert('Error checking marksheet template. Please try again.');
    }
  };

  const fetchStudentMarksheet = async (studentId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/marksheet/${studentId}`);
      if (response.data) {
        setMarksheetData({
          ...response.data.exams,
          visibility: response.data.visibility || {
            term1: false,
            term2: false,
            halfYearly: false,
            term3: false,
            project: false,
            annualExam: false,
            finalResult: false
          }
        });
      }
    } catch (error) {
      console.error('Error fetching marksheet:', error);
      if (error.response?.status === 404) {
        console.log('No existing marksheet found, initializing empty data');
      }
      initializeMarksheetData();
    }
  };

  const saveMarksheet = async () => {
    if (!selectedStudent) return;
    
    try {
      const { visibility, ...exams } = marksheetData;
      const marksheetPayload = {
        studentId: selectedStudent._id.toString(),
        name: selectedStudent.name,
        fathersName: selectedStudent.fathersName || 'N/A',
        class: selectedStudent.class,
        classTeacher: user.name,
        visibility: visibility,
        exams: exams
      };
      
      await axios.put(`${API_BASE_URL}/api/marksheet/${selectedStudent._id}`, marksheetPayload);
      alert('Marksheet saved successfully!');
      setShowMarksheetModal(false);
    } catch (error) {
      console.error('Error saving marksheet:', error);
      console.error('Error details:', error.response?.data);
      alert('Error saving marksheet: ' + (error.response?.data?.message || error.message));
    }
  };

  const updateMarksheetField = (exam, subject, value) => {
    setMarksheetData(prev => ({
      ...prev,
      [exam]: {
        ...prev[exam],
        [subject]: value
      }
    }));
  };

  const openIdCardModal = (student) => {
    setSelectedStudent(student);
    setShowIdCardModal(true);
    fetchStudentIdCard(student._id);
  };

  const fetchStudentIdCard = async (studentId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/idcard/${studentId}`);
      if (response.data) {
        // Ensure class is set correctly from either ID card data or selected student
        setIdCardData({
          ...response.data,
          class: response.data.class || selectedStudent?.class || ''
        });
      }
    } catch (error) {
      console.error('Error fetching ID card:', error);
      setIdCardData({
        name: selectedStudent?.name || '',
        class: selectedStudent?.class || '',
        dob: '',
        fathersName: '',
        mothersName: '',
        mobile: '',
        scholarNo: '',
        address: ''
      });
    }
  };

  const saveIdCard = async () => {
    if (!selectedStudent) return;
    
    try {
      const idCardPayload = {
        studentId: selectedStudent._id.toString(),
        name: selectedStudent.name,
        class: selectedStudent.class,
        ...idCardData,
        // Ensure class is always set correctly
        class: idCardData.class || selectedStudent.class
      };
      
      await axios.put(`${API_BASE_URL}/api/idcard/${selectedStudent._id}`, idCardPayload);
      alert('ID Card saved successfully!');
      setShowIdCardModal(false);
    } catch (error) {
      console.error('Error saving ID card:', error);
      alert('Error saving ID card: ' + (error.response?.data?.message || error.message));
    }
  };

  const updateIdCardField = (field, value) => {
    setIdCardData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const fetchClasswork = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/classwork/${user.class}`);
      setClassworkData(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error('Error fetching classwork:', error);
      setClassworkData([]);
    }
  };

  const handleClassworkSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_BASE_URL}/api/classwork`, {
        teacherId: user.id,
        class: user.class,
        date: newClasswork.date,
        type: newClasswork.type,
        subject: newClasswork.subject,
        message: newClasswork.message
      });
      setNewClasswork({ date: '', type: 'classwork', subject: 'Hindi', message: '' });
      setShowClassworkModal(false);
      fetchClasswork();
      alert('Classwork/Homework added successfully!');
    } catch (error) {
      console.error('Error adding classwork:', error);
      alert('Error adding classwork');
    }
  };

  const editClasswork = async (item) => {
    const newMessage = prompt('Edit Message:', item.message);
    if (newMessage) {
      try {
        await axios.put(`${API_BASE_URL}/api/classwork/${item._id}`, {
          message: newMessage
        });
        fetchClasswork();
        alert('Classwork updated successfully!');
      } catch (error) {
        console.error('Error updating classwork:', error);
        alert('Error updating classwork');
      }
    }
  };

  const deleteClasswork = async (itemId) => {
    if (window.confirm('Are you sure you want to delete this classwork/homework?')) {
      try {
        await axios.delete(`${API_BASE_URL}/api/classwork/${itemId}`);
        fetchClasswork();
        alert('Classwork deleted successfully!');
      } catch (error) {
        console.error('Error deleting classwork:', error);
        alert('Error deleting classwork');
      }
    }
  };

  const impersonateTeacher = (teacher) => {
    if (onImpersonate) {
      onImpersonate(teacher);
    }
  };

  const impersonateStudent = async (student) => {
    try {
      // Store current teacher session
      const teacherSession = {
        user: {
          id: user.id,
          name: user.name,
          email: user.email,
          role: user.role,
          class: user.class,
          _id: user._id
        },
        timestamp: Date.now()
      };
      sessionStorage.setItem('teacherSession', JSON.stringify(teacherSession));
      
      // Create student session with proper structure
      const studentUser = {
        id: student._id,
        _id: student._id,
        name: student.name,
        email: student.email,
        role: 'student',
        class: student.class,
        section: student.section,
        impersonatedBy: user.name,
        originalRole: user.role,
        studentId: student.studentId || student._id
      };
      
      // Store student session and impersonation flag
      localStorage.setItem('user', JSON.stringify(studentUser));
      localStorage.setItem('isImpersonating', 'true');
      localStorage.setItem('originalTeacher', JSON.stringify(teacherSession.user));
      
      window.location.reload();
    } catch (error) {
      console.error('Error impersonating student:', error);
      alert('Failed to access student account. Please try again.');
    }
  };

  const getClassCategory = (className) => {
    if (!className) return 'primary';
    const lowerClass = className.toLowerCase();
    if (lowerClass.includes('nursery') || lowerClass.includes('lkg') || lowerClass.includes('hkg')) {
      return 'preschool';
    }
    return 'primary';
  };

  const loadDynamicSubjects = () => {
    const normalizedClass = user.class?.replace('Class ', '') || user.class;
    const classCategory = getClassCategory(normalizedClass);
    const subjectKey = classCategory === 'preschool' ? 'preschool_subjects' : 'school_subjects';
    const savedSubjects = localStorage.getItem(subjectKey);
    
    if (savedSubjects) {
      setDynamicSubjects(JSON.parse(savedSubjects));
    } else {
      const defaultSubjects = classCategory === 'preschool' ? [
        'Play', 'Drawing', 'Story Time', 'Music', 'Dance', 'Craft', 'Games', 'Snack', 'Rest'
      ] : [
        'Math', 'English', 'Hindi', 'Science', 'Social Studies', 'EVS', 'Sports', 'Art', 'Music', 'Computer', 'Library', 'Assembly', 'Break', 'Lunch'
      ];
      setDynamicSubjects(defaultSubjects);
      localStorage.setItem(subjectKey, JSON.stringify(defaultSubjects));
    }
  };

  const fetchAttendanceVisibility = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/attendance-visibility/${user.class}`);
      setAttendanceVisibility(response.data.showDailyStatus);
    } catch (error) {
      console.error('Error fetching attendance visibility:', error);
      setAttendanceVisibility(true);
    }
  };

  const updateAttendanceVisibility = async (showStatus) => {
    try {
      await axios.put(`${API_BASE_URL}/api/attendance-visibility/${user.class}`, {
        showDailyStatus: showStatus,
        updatedBy: user.name
      });
      setAttendanceVisibility(showStatus);
      alert(`✅ P/A indicators updated!\n\n"P" and "A" indicators on calendar days are now ${showStatus ? 'VISIBLE' : 'HIDDEN'} for students.\n\nAttendance summary remains visible.`);
    } catch (error) {
      console.error('Error updating attendance visibility:', error);
      alert('❌ Failed to update P/A indicator visibility. Please try again.');
    }
  };

  const showSection = (sectionId) => {
    setActiveSection(sectionId);

    // Smooth scroll to top when switching sections
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const openFromHome = (sectionId) => {
    setActiveSection(sectionId);
    setShowHome(false);
    window.scrollTo(0, 0);
  };

  return (
    <>
    <JoinLiveClassButton />
    <TeacherHome
      user={user}
      onLogout={onLogout}
      isTeacherAdmin={isTeacherAdmin}
      isImpersonating={isImpersonating || isPrincipalImpersonating}
      onStopImpersonation={onStopImpersonation}
      legacyOpen={!showHome}
      legacyTitle={activeSection}
      onCloseLegacy={() => setShowHome(true)}
      onOpenSection={openFromHome}
      onChangePassword={() => setShowChangePassword(true)}
      onViewAsStudent={impersonateStudent}
    >

      <div className="dashboard-grid" style={{ 
        minHeight: 'auto', 
        paddingBottom: '50px',
        paddingTop: activeSection !== 'timetable' && activeSection !== 'attendance' ? '20px' : '0'
      }}>
        {activeSection === 'quickmark' && (
          <QuickMarkDashboard user={user} onClose={() => setShowHome(true)} />
        )}

        {activeSection === 'mycompliance' && (
          <MyComplianceCard user={user} />
        )}

        {activeSection === 'unifieddesk' && (
          <div style={{ gridColumn: '1 / -1' }}>
            <MyComplianceCard user={user} />
            <TeacherUnifiedDesk user={user} />
          </div>
        )}

        {activeSection === 'classanalytics' && (
          <div style={{ gridColumn: '1 / -1' }}>
            <ClassAnalyticsDashboard user={user} classId={user?.class || user?.assignedClass} />
          </div>
        )}

        {activeSection === 'attendancemaster' && (
          <AttendanceMaster user={user} onClose={() => setShowHome(true)} />
        )}

        {activeSection === 'dailyhw' && (
          <DailyAttendanceView
            selectedDate={getCurrentDateIST()}
            userClass={user.class || user.assignedClass || user.classId}
            onClose={() => setShowHome(true)}
          />
        )}

        {activeSection === 'attendance' && (
          <div className="card" style={{ gridColumn: 'span 2' }}>
            <h3>📅 Attendance Management</h3>
            <AttendanceCalendar 
              userClass={user.class} 
              userRole="teacher" 
              students={students} 
              userId={user.id}
              onDateClick={(date) => {
                setSelectedAttendanceDate(date);
                setShowDailyAttendance(true);
              }}
            />
          </div>
        )}

        {activeSection === 'superteacher' && isTeacherAdmin && (
          <div id="superteacher" className="card" style={{ gridColumn: 'span 2', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
            <h3 style={{ color: 'white' }}>🎭 Teacher Admin Level 1 - Super Teacher Controls</h3>
            <div style={{ marginBottom: '15px', padding: '15px', background: 'rgba(255,255,255,0.1)', borderRadius: '10px' }}>
              <h4 style={{ margin: '0 0 10px 0', color: 'white' }}>⚡ Super Teacher Privileges</h4>
              <ul style={{ margin: '0', paddingLeft: '20px', fontSize: '14px', color: 'rgba(255,255,255,0.9)' }}>
                <li>Access any teacher's account directly (impersonation)</li>
                <li>Manage all teacher accounts and permissions</li>
                <li>Create and assign roles for teachers</li>
                <li>Full authority over teacher management</li>
              </ul>
            </div>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              <button 
                onClick={() => setShowTeacherList(!showTeacherList)}
                style={{ 
                  background: 'rgba(255,255,255,0.2)', 
                  color: 'white', 
                  border: '1px solid rgba(255,255,255,0.3)', 
                  padding: '10px 20px', 
                  borderRadius: '8px', 
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: 'bold'
                }}
              >
                {showTeacherList ? '🔼 Hide Teachers' : '👥 Manage All Teachers'}
              </button>
            </div>
            
            {showTeacherList && (
              <div style={{ marginTop: '20px', maxHeight: '400px', overflowY: 'auto' }}>
                <h4 style={{ color: 'white', marginBottom: '15px' }}>👨🏫 All Teachers ({allTeachers.length})</h4>
                {allTeachers.map(teacher => (
                  <div key={teacher._id} style={{ 
                    marginBottom: '10px', 
                    padding: '15px', 
                    background: 'rgba(255,255,255,0.1)', 
                    borderRadius: '10px',
                    border: '1px solid rgba(255,255,255,0.2)'
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                        <div style={{ 
                          width: '50px', 
                          height: '50px', 
                          borderRadius: '50%', 
                          background: teacher.profilePicture 
                            ? `url(${teacher.profilePicture}) center/cover no-repeat` 
                            : 'rgba(255,255,255,0.2)',
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'center', 
                          fontSize: '20px',
                          border: '2px solid rgba(255,255,255,0.3)'
                        }}>
                          {!teacher.profilePicture && '👨🏫'}
                        </div>
                        <div>
                          <strong style={{ fontSize: '16px', color: 'white' }}>{teacher.name}</strong>
                          <p style={{ margin: '2px 0', color: 'rgba(255,255,255,0.8)', fontSize: '14px' }}>Class: {teacher.class || 'Unassigned'}</p>
                          <small style={{ color: 'rgba(255,255,255,0.7)' }}>{teacher.email}</small>
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <button 
                          onClick={() => impersonateTeacher(teacher)}
                          style={{ 
                            background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%)', 
                            color: 'white', 
                            border: 'none', 
                            padding: '8px 16px', 
                            borderRadius: '6px', 
                            cursor: 'pointer',
                            fontSize: '12px',
                            fontWeight: 'bold'
                          }}
                        >
                          🎭 Impersonate
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {activeSection === 'timetable' && (
        <div id="timetable" className="card" style={{ gridColumn: 'span 2' }}>
          <h3>📅 My Weekly Timetable</h3>
          <div style={{ marginBottom: '15px' }}>
            <p>Your teaching schedule and assigned classes</p>
          </div>
          <TimetableManager 
            userRole="teacher" 
            userId={user.id} 
            userName={user.name}
            autoLoad={true}
            embedded={true}
          />
        </div>
        )}

        {activeSection === 'diary' && (
        <div id="diary" className="card">
          <h3>📚 Teacher's Diary Management</h3>
          <div style={{ marginBottom: '15px' }}>
            <p>Create and share daily diary entries with subjects, topics, and homework</p>
            <div style={{ padding: '12px', background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)', borderRadius: '8px', marginBottom: '12px', border: '1px solid #2196f3' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                <div style={{ background: '#2196f3', color: 'white', borderRadius: '50%', width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px' }}> </div>
                <div>
                  <strong style={{ color: '#1565c0', fontSize: '16px' }}>Enhanced Diary System</strong>
                  <p style={{ margin: '2px 0 0 0', fontSize: '12px', color: '#1976d2' }}>Subject-wise entries with WhatsApp sharing</p>
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px', fontSize: '11px', color: '#1565c0' }}>
                <div>✓ Topic Taught</div>
                <div>✓ Homework Assigned</div>
                <div>✓ WhatsApp Share</div>
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            <button 
              className="btn" 
              onClick={() => setShowDiaryPopup(true)}
              style={{ background: 'linear-gradient(135deg, #2196f3 0%, #1976d2 100%)', color: 'white', fontWeight: 'bold', padding: '10px 16px' }}
            >
              📚 Open Diary
            </button>

            <button className="btn" onClick={() => setShowClassworkModal(true)}>📝 Quick Classwork/Homework</button>
            
            <button 
              className="btn" 
              onClick={() => setShowDeviceMonitor(true)}
              style={{ background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)', color: 'white', fontWeight: 'bold', padding: '10px 16px' }}
            >
              📱 Monitor Student Devices
            </button>
          </div>
          
          <div style={{ marginTop: '20px', maxHeight: '200px', overflowY: 'auto' }}>
            <h4>Recent Messages:</h4>
            {Array.isArray(classworkData) && classworkData.length > 0 ? (
              (Array.isArray(classworkData) ? classworkData : []).slice(0, 5).map(item => (
                <div key={item._id} style={{ padding: '8px', background: item.type === 'classwork' ? '#e3f2fd' : '#fff3e0', borderRadius: '4px', marginBottom: '8px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div style={{ flex: 1 }}>
                      <p><strong>{item.type === 'classwork' ? ' ' : '📝'} {item.subject}</strong> - {item.date}</p>
                      <p style={{ fontSize: '12px', margin: '4px 0' }}>{item.message}</p>
                    </div>
                    <div style={{ display: 'flex', gap: '5px', marginLeft: '10px' }}>
                      <button 
                        className="btn" 
                        style={{ background: '#007bff', fontSize: '10px', padding: '3px 6px' }}
                        onClick={() => editClasswork(item)}
                      >
                        Edit
                      </button>
                      <button 
                        className="btn" 
                        style={{ background: '#dc3545', fontSize: '10px', padding: '3px 6px' }}
                        onClick={() => deleteClasswork(item._id)}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p style={{ color: '#666', fontStyle: 'italic' }}>No messages sent yet</p>
            )}
          </div>
        </div>
        )}

        {activeSection === 'students' && (
        <div id="students" className="card">
          <h3>👨🎓 Student Profiles</h3>
          {(user.name === 'admin1' || user.email === 'a1@s.com' || user.role === 'admin1') && (
            <div style={{ marginBottom: '15px', padding: '10px', background: 'rgba(245, 158, 11, 0.1)', borderRadius: '8px', border: '1px solid #f59e0b' }}>
              <p style={{ fontSize: '14px', fontWeight: '600', color: '#92400e', margin: '0 0 8px 0' }}>🔧 Admin Level 1 Controls</p>
              <button 
                onClick={() => setShowTemplateManager(true)}
                style={{ background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}
              >
                📋 Manage Marksheet Templates
              </button>
            </div>
          )}
          <div style={{ 
            maxHeight: showAllStudents ? '400px' : 'none', 
            overflowY: showAllStudents ? 'auto' : 'visible',
            transition: 'all 0.3s ease'
          }}>
            {(showAllStudents ? students : students.slice(0, 3)).map(student => (
              <div key={student._id} style={{ 
                marginBottom: '10px', 
                padding: '10px', 
                background: '#f8f9fa', 
                borderRadius: '5px',
                opacity: 1,
                transform: 'translateY(0)',
                transition: 'all 0.2s ease'
              }}>
                <strong>{student.name}</strong>
                <p>Email: {student.email}</p>
                <p>Attendance: 92% | Performance: B+</p>
                <div style={{ display: 'flex', gap: '5px', marginTop: '10px', flexWrap: 'wrap' }}>
                  <button className="btn" onClick={() => viewStudentProfile(student)}>View Profile</button>
                  <button className="btn" style={{ background: '#f59e0b', fontSize: '12px', padding: '6px 12px' }} onClick={() => openMarksheetModal(student)}>📋 Enter Marks</button>
                  <button className="btn" style={{ background: '#10b981', fontSize: '12px', padding: '6px 12px' }} onClick={() => openIdCardModal(student)}>🆔 ID Card</button>
                  <button 
                    className="btn" 
                    style={{ background: '#8b5cf6', fontSize: '12px', padding: '6px 12px', color: 'white' }} 
                    onClick={() => {
                      setSelectedStudent(student);
                      fetchStudentIdCard(student._id);
                      setShowIdCard(true);
                    }}
                  >
                    👁️ View ID
                  </button>
                  <button 
                    className="btn" 
                    style={{ background: '#25d366', fontSize: '12px', padding: '6px 12px', color: 'white' }} 
                    onClick={() => {
                      setSelectedStudentForWhatsApp(student);
                      setShowWhatsAppMessenger(true);
                    }}
                  >
                    📱 WhatsApp
                  </button>
                  <button 
                    onClick={() => impersonateStudent(student)}
                    style={{ 
                      background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)', 
                      color: 'white', 
                      border: 'none', 
                      padding: '6px 12px', 
                      borderRadius: '6px', 
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      boxShadow: '0 3px 10px rgba(139, 92, 246, 0.3)',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = 'linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)';
                      e.target.style.transform = 'translateY(-1px)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)';
                      e.target.style.transform = 'translateY(0)';
                    }}
                  >
                    🚪 Access Account
                  </button>
                </div>
              </div>
            ))}
          </div>
          <button 
            className="btn" 
            onClick={() => setShowAllStudents(!showAllStudents)}
            style={{ 
              background: showAllStudents ? '#6c757d' : '#007bff',
              transition: 'all 0.3s ease',
              transform: showAllStudents ? 'scale(0.98)' : 'scale(1)'
            }}
          >
            {showAllStudents ? 'Hide Students' : 'View All Students'}
          </button>
        </div>
        )}

        {activeSection === 'behavior' && !showBehaviorChart && (
          <div className="card">
            <h3>📋 Student Discipline Management</h3>
            <div style={{ marginBottom: '15px' }}>
              <p>Update discipline records for your students ({students.length} total)</p>
              <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                {students.map(student => (
                  <div key={student._id} style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    padding: '8px', 
                    background: '#f8f9fa', 
                    borderRadius: '4px', 
                    marginBottom: '8px' 
                  }}>
                    <div>
                      <strong>{student.name}</strong>
                      <p style={{ margin: '2px 0', fontSize: '12px', color: '#666' }}>
                        Behavior: {student.behaviorScore || 'Not Set'} | Warnings: {student.warnings || '0'}
                      </p>
                    </div>
                    <div style={{ display: 'flex', gap: '5px', marginLeft: '10px' }}>
                      <button 
                        className="btn" 
                        style={{ fontSize: '12px', padding: '4px 8px', background: '#3b82f6' }}
                        onClick={() => {
                          setSelectedStudentForBehavior(student);
                          setShowBehaviorChart(true);
                        }}
                      >
                        📊 Evaluate
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {activeSection === 'behavior' && showBehaviorChart && selectedStudentForBehavior && (
          <div className="card" style={{ 
            gridColumn: 'span 2', 
            background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)', 
            border: '2px solid #0ea5e9',
            minHeight: '600px',
            maxHeight: 'none',
            overflow: 'visible'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h3 style={{ margin: 0, color: '#0c4a6e' }}>📊 Student Behavior Evaluation - {selectedStudentForBehavior.name}</h3>
              <button
                onClick={() => {
                  setShowBehaviorChart(false);
                  setSelectedStudentForBehavior(null);
                }}
                style={{
                  background: '#dc2626',
                  color: 'white',
                  border: 'none',
                  padding: '8px 16px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: 'bold'
                }}
              >
                ✖ Hide
              </button>
            </div>
            <div style={{ overflow: 'visible', minHeight: '500px' }}>
              <StudentBehaviorRadarChart 
                student={selectedStudentForBehavior}
                onClose={() => {
                  setShowBehaviorChart(false);
                  setSelectedStudentForBehavior(null);
                }}
                onSave={async (evaluationData) => {
                  try {
                    await axios.put(`${API_BASE_URL}/api/behavior-evaluation/${selectedStudentForBehavior._id}`, {
                      behaviorRatings: evaluationData.behaviorRatings,
                      evaluatedBy: user.name
                    });
                    alert('Behavior evaluation saved successfully!');
                    setShowBehaviorChart(false);
                    setSelectedStudentForBehavior(null);
                  } catch (error) {
                    console.error('Error saving evaluation:', error);
                    alert('Error saving evaluation');
                  }
                }}
              />
            </div>
          </div>
        )}

        {activeSection === 'content' && (
        <div id="content" className="card">
          <h3>📚 Upload Class Content</h3>
          <form onSubmit={handleContentUpload}>
            <div className="form-group">
              <label>Title:</label>
              <input
                type="text"
                value={newContent.title}
                onChange={(e) => setNewContent({...newContent, title: e.target.value})}
                required
              />
            </div>
            <div className="form-group">
              <label>Description:</label>
              <textarea
                value={newContent.description}
                onChange={(e) => setNewContent({...newContent, description: e.target.value})}
                required
              />
            </div>
            <div className="form-group">
              <label>Type:</label>
              <select
                value={newContent.type}
                onChange={(e) => setNewContent({...newContent, type: e.target.value})}
              >
                <option value="note">Daily Note</option>
                <option value="assignment">Assignment</option>
                <option value="material">Study Material</option>
              </select>
            </div>
            <div className="form-group">
              <label>Upload File (PDF, DOC, etc.) - Max 1MB:</label>
              <input 
                type="file" 
                accept=".pdf,.doc,.docx,.ppt,.pptx,.txt,.jpg,.jpeg,.png" 
                style={{ marginBottom: '10px' }}
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file && file.size > 1024 * 1024) {
                    alert('File size exceeds 1MB limit. Please choose a smaller file.');
                    e.target.value = '';
                  }
                }}
              />
              <small style={{ color: '#666', fontSize: '12px', display: 'block' }}>⚠️ Maximum file size: 1MB</small>
            </div>
            <button type="submit" className="btn">Upload Content</button>
          </form>
        </div>
        )}

        {activeSection === 'homework' && (
        <div id="homework" className="card">
          <h3>📝 Homework Management</h3>
          <div style={{ marginBottom: '15px' }}>
            <p><strong>Active Assignments:</strong></p>
            {assignments.length > 0 ? (
              assignments.map(assignment => (
                <div key={assignment._id} style={{ padding: '8px', background: '#fff3cd', borderRadius: '4px', marginBottom: '8px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div style={{ flex: 1 }}>
                      <p><strong>{assignment.title}</strong></p>
                      <p>{assignment.description}</p>
                      <small>Created: {new Date(assignment.createdAt).toLocaleDateString()}</small>
                    </div>
                    <div style={{ display: 'flex', gap: '5px', marginLeft: '10px' }}>
                      <button 
                        className="btn" 
                        style={{ background: '#007bff', fontSize: '12px', padding: '4px 8px' }}
                        onClick={() => editAssignment(assignment)}
                      >
                        Edit
                      </button>
                      <button 
                        className="btn" 
                        style={{ background: '#dc3545', fontSize: '12px', padding: '4px 8px' }}
                        onClick={() => deleteAssignment(assignment._id)}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p style={{ color: '#666', fontStyle: 'italic' }}>No assignments created yet</p>
            )}
          </div>
          <button className="btn" onClick={createAssignment}>Create New Assignment</button>
          <button className="btn" onClick={reviewSubmissions}>Review Submissions</button>
        </div>
        )}

        {activeSection === 'ranking' && (
        <div id="ranking" className="card">
          <h3>⭐ My Monthly Ranking</h3>
          <div style={{ marginBottom: '15px' }}>
            {myRanking ? (
              <div>
                <div style={{ padding: '15px', background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)', borderRadius: '10px', marginBottom: '15px', textAlign: 'center' }}>
                  <div style={{ fontSize: '32px', fontWeight: 'bold', color: '#92400e', marginBottom: '5px' }}>{myRanking.averageScore}/10</div>
                  <div style={{ fontSize: '14px', color: '#92400e' }}>Overall Rating - {new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}</div>
                  <div style={{ fontSize: '12px', color: '#a16207', marginTop: '5px' }}>Ranked by: {myRanking.rankedBy}</div>
                </div>
                <button 
                  onClick={() => setShowRanking(!showRanking)}
                  style={{ background: showRanking ? '#6c757d' : '#f59e0b', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold', width: '100%' }}
                >
                  {showRanking ? 'Hide Details' : 'View Detailed Ranking'}
                </button>
                {showRanking && (
                  <div style={{ marginTop: '15px', maxHeight: '300px', overflowY: 'auto', border: '1px solid #ddd', borderRadius: '8px', background: '#f8f9fa' }}>
                    {Object.entries(myRanking?.ranking || {}).map(([param, score]) => (
                      <div key={param} style={{ padding: '8px 12px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span style={{ fontSize: '13px', fontWeight: '500' }}>{param}</span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <div style={{ width: '60px', height: '6px', background: '#e0e0e0', borderRadius: '3px', overflow: 'hidden' }}>
                            <div style={{ width: `${(score/10)*100}%`, height: '100%', background: score >= 7 ? '#4caf50' : score >= 5 ? '#ff9800' : '#f44336', borderRadius: '3px' }}></div>
                          </div>
                          <span style={{ fontSize: '14px', fontWeight: 'bold', color: score >= 7 ? '#4caf50' : score >= 5 ? '#ff9800' : '#f44336', minWidth: '30px' }}>{score}/10</span>
                        </div>
                      </div>
                    ))}
                    {myRanking.comments && (
                      <div style={{ padding: '12px', background: '#e3f2fd', borderRadius: '0 0 8px 8px' }}>
                        <div style={{ fontWeight: 'bold', fontSize: '13px', color: '#1565c0', marginBottom: '5px' }}>Principal's Comments:</div>
                        <div style={{ fontSize: '12px', color: '#1976d2' }}>{myRanking.comments}</div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : (
              <div style={{ textAlign: 'center', padding: '30px', color: '#666' }}>
                <div style={{ fontSize: '48px', marginBottom: '10px' }}>⭐</div>
                <div style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '5px' }}>No Ranking Yet</div>
                <div style={{ fontSize: '14px' }}>Your monthly ranking will appear here once evaluated by the Principal</div>
              </div>
            )}
          </div>
        </div>
        )}

        {activeSection === 'myattendance' && (
        <div id="myattendance" className="card">
          <h3>📅 My Attendance</h3>
          <div style={{ marginBottom: '15px' }}>
            {(() => {
              const stats = getAttendanceStats();
              return (
                <div>
                  <div style={{ padding: '10px', background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)', borderRadius: '8px', marginBottom: '10px' }}>
                    <p style={{ margin: '0 0 5px 0', fontSize: '16px', fontWeight: 'bold', color: '#1565c0' }}>This Month's Summary</p>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '8px', fontSize: '14px' }}>
                      <div><strong>Present:</strong> {stats.presentDays} days</div>
                      <div><strong>Late:</strong> {stats.lateDays} days</div>
                      <div><strong>Absent:</strong> {stats.absentDays} days</div>
                      <div><strong>Percentage:</strong> {stats.percentage}%</div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button 
                      className="btn" 
                      onClick={() => setShowMyAttendance(!showMyAttendance)}
                      style={{ background: showMyAttendance ? '#6c757d' : '#007bff', fontSize: '12px', padding: '6px 12px' }}
                    >
                      {showMyAttendance ? 'Hide Details' : 'View Details'}
                    </button>
                    <button 
                      className="btn" 
                      onClick={() => setShowEnhancedAttendanceView(true)}
                      style={{ background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', color: 'white', fontSize: '12px', padding: '6px 12px', fontWeight: 'bold' }}
                    >
                      📊 Enhanced View
                    </button>
                  </div>
                  {showMyAttendance && (
                    <div style={{ marginTop: '10px', maxHeight: '200px', overflowY: 'auto', border: '1px solid #ddd', borderRadius: '6px' }}>
                      {(myAttendance || []).length > 0 ? (
                        (myAttendance || []).slice().reverse().map(record => (
                          <div key={record._id} style={{ 
                            padding: '8px', 
                            borderBottom: '1px solid #eee', 
                            display: 'flex', 
                            justifyContent: 'space-between',
                            alignItems: 'center'
                          }}>
                            <div>
                              <strong>{new Date(record.date).toLocaleDateString()}</strong>
                              {record.remarks && <p style={{ margin: '2px 0 0 0', fontSize: '12px', color: '#666' }}>{record.remarks}</p>}
                            </div>
                            <span style={{ 
                              padding: '3px 8px', 
                              borderRadius: '12px', 
                              fontSize: '11px', 
                              fontWeight: 'bold',
                              background: record.status === 'present' ? '#4caf50' : record.status === 'late' ? '#ff9800' : '#f44336',
                              color: 'white'
                            }}>
                              {record.status.toUpperCase()}
                            </span>
                          </div>
                        ))
                      ) : (
                        <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>No attendance records found</div>
                      )}
                    </div>
                  )}
                </div>
              );
            })()}
          </div>
        </div>
        )}

        {activeSection === 'progress' && (
        <div id="progress" className="card">
          <h3>📈 Student Progress</h3>
          <div style={{ marginBottom: '15px' }}>
            <p><strong>Class Average: 82%</strong></p>
            <p>Top Performer: John Student (95%)</p>
            <p>Needs Attention: 3 students</p>
          </div>
          <button className="btn" onClick={viewProgress}>Generate Progress Report</button>
        </div>
        )}



        {activeSection === 'announcements' && (
        <div id="announcements" className="card">
          <h3>📣 Class Announcements</h3>
          <textarea 
            id="announcement-textarea"
            placeholder="Write announcement for your class..." 
            style={{ marginBottom: '10px', minHeight: '60px' }}
          ></textarea>
          <div style={{ marginBottom: '10px' }}>
            <label>
              <input type="checkbox" /> Send to parents
            </label>
          </div>
          <button className="btn" onClick={postAnnouncement}>Post Announcement</button>
        </div>
        )}

        {activeSection === 'online' && (
        <div id="online" className="card">
          <h3>💻 Manage Online Content</h3>
          
          <div style={{ marginBottom: '20px', padding: '15px', background: '#f0f8ff', borderRadius: '8px', border: '2px solid #007bff' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#007bff' }}>🎓 Complete Course Link</h4>
            {Array.isArray(existingCourseLinks) && existingCourseLinks.filter(link => link.title === 'Complete Course').length > 0 ? (
              <div>
                {(Array.isArray(existingCourseLinks) ? existingCourseLinks : []).filter(link => link.title === 'Complete Course').map(link => (
                  <div key={link._id} style={{ padding: '12px', background: 'rgba(16, 185, 129, 0.1)', borderRadius: '8px', border: '1px solid #10b981' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div>
                        <h5 style={{ margin: '0 0 4px 0', color: '#065f46', fontSize: '16px', fontWeight: '600' }}>🎓 {link.title}</h5>
                        <p style={{ margin: '0 0 6px 0', color: '#374151', fontSize: '14px' }}>{link.description}</p>
                        <small style={{ color: '#6b7280', fontSize: '12px' }}>Added: {new Date(link.createdAt).toLocaleDateString()}</small>
                      </div>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <button 
                          onClick={() => window.open(link.resourceLink, '_blank')}
                          style={{ background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}
                        >
                          🔗 Open Course
                        </button>
                        <button 
                          onClick={() => editCourseLink(link)}
                          style={{ background: '#007bff', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}
                        >
                          ✏️ Edit
                        </button>
                        <button 
                          onClick={() => deleteCourseLink(link._id)}
                          style={{ background: '#dc3545', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}
                        >
                          🗑️ Delete
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '10px', alignItems: 'center' }}>
                  <input
                    type="url"
                    placeholder="Enter complete course link (e.g., https://classroom.google.com/...)"
                    style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '14px' }}
                    onKeyPress={async (e) => {
                      if (e.key === 'Enter') {
                        const link = e.target.value;
                        if (link) {
                          try {
                            await axios.post('/api/course-links', {
                              title: 'Complete Course',
                              description: 'Access to complete course materials for all subjects',
                              resourceLink: link,
                              linkType: 'website',
                              class: user.class,
                              uploadedBy: user.name
                            });
                            e.target.value = '';
                            fetchExistingCourseLinks();
                            alert('Complete course link added successfully!');
                          } catch (error) {
                            console.error('Error adding course link:', error);
                            alert('Error adding course link');
                          }
                        }
                      }
                    }}
                  />
                  <button 
                    type="button"
                    onClick={async () => {
                      const input = document.querySelector('input[placeholder*="complete course"]');
                      const link = input.value;
                      if (link) {
                        try {
                          await axios.post('/api/course-links', {
                            title: 'Complete Course',
                            description: 'Access to complete course materials for all subjects',
                            resourceLink: link,
                            linkType: 'website',
                            class: user.class,
                            uploadedBy: user.name
                          });
                          input.value = '';
                          fetchExistingCourseLinks();
                          alert('Complete course link added successfully!');
                        } catch (error) {
                          console.error('Error adding course link:', error);
                          alert('Error adding course link');
                        }
                      } else {
                        alert('Please enter a course link');
                      }
                    }}
                    style={{ background: '#007bff', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' }}
                  >
                    🔗 Add Course
                  </button>
                </div>
                <small style={{ color: '#666', fontSize: '12px' }}>This will be the main course link for all subjects</small>
              </div>
            )}
          </div>
          
          <form onSubmit={handleOnlineContentSubmit}>
            <div className="form-group">
              <label>Subject:</label>
              <select
                value={onlineContent.subject}
                onChange={(e) => setOnlineContent({...onlineContent, subject: e.target.value})}
                required
              >
                {dynamicSubjects.map(subject => (
                  <option key={subject} value={subject}>{subject}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Title/Topic:</label>
              <input
                type="text"
                value={onlineContent.title}
                onChange={(e) => setOnlineContent({...onlineContent, title: e.target.value})}
                placeholder="e.g., Chapter 5 - Fractions"
                required
              />
            </div>
            <div className="form-group">
              <label>Description:</label>
              <textarea
                value={onlineContent.description}
                onChange={(e) => setOnlineContent({...onlineContent, description: e.target.value})}
                placeholder="Brief description or usage instructions"
                rows="2"
              />
            </div>
            <div className="form-group">
              <label>Resource Link:</label>
              <input
                type="url"
                value={onlineContent.resourceLink}
                onChange={(e) => setOnlineContent({...onlineContent, resourceLink: e.target.value})}
                placeholder="https://youtube.com/watch?v=..."
                required
              />
            </div>
            <div className="form-group">
              <label>Link Type:</label>
              <select
                value={onlineContent.linkType}
                onChange={(e) => setOnlineContent({...onlineContent, linkType: e.target.value})}
              >
                <option value="youtube">YouTube Video</option>
                <option value="drive">Google Drive</option>
                <option value="pdf">PDF Document</option>
                <option value="website">Website</option>
                <option value="other">Other</option>
              </select>
            </div>
            <button type="submit" className="btn">Add Online Content</button>
          </form>
          
          <div style={{ marginTop: '20px' }}>
            <h4>  Subject-wise Online Content:</h4>
            {dynamicSubjects.map(subject => {
              const subjectContent = Array.isArray(existingOnlineContent) ? existingOnlineContent.filter(item => item.subject === subject) : [];
              if (subjectContent.length === 0) return null;
              
              return (
                <div key={subject} style={{ marginBottom: '15px' }}>
                  <h5 style={{ color: '#007bff', fontSize: '14px', marginBottom: '8px', padding: '6px 10px', background: '#e3f2fd', borderRadius: '6px' }}>📖 {subject}</h5>
                  {subjectContent.map(content => (
                    <div key={content._id} style={{ padding: '8px', background: '#e8f5e8', borderRadius: '4px', marginBottom: '6px' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <div style={{ flex: 1 }}>
                          <p style={{ margin: '0 0 4px 0', fontSize: '13px' }}><strong>{content.title}</strong></p>
                          <p style={{ margin: '0 0 4px 0', fontSize: '11px', color: '#666' }}>{content.description}</p>
                          <small style={{ fontSize: '10px', color: '#888' }}>Added: {new Date(content.createdAt).toLocaleDateString()}</small>
                        </div>
                        <div style={{ display: 'flex', gap: '3px', marginLeft: '8px' }}>
                          <button 
                            className="btn" 
                            style={{ background: '#007bff', fontSize: '10px', padding: '3px 6px' }}
                            onClick={() => editOnlineContent(content)}
                          >
                            Edit
                          </button>
                          <button 
                            className="btn" 
                            style={{ background: '#dc3545', fontSize: '10px', padding: '3px 6px' }}
                            onClick={() => deleteOnlineContent(content._id)}
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              );
            })}
            {(!Array.isArray(existingOnlineContent) || existingOnlineContent.length === 0) && (
              <p style={{ color: '#666', fontStyle: 'italic', textAlign: 'center', padding: '20px' }}>No subject-wise content added yet</p>
            )}
          </div>
        </div>
        )}

        {activeSection === 'courselinks' && (
        <div id="courselinks" className="card">
          <h3>🔗 Additional Course Links</h3>
          <form onSubmit={handleCourseLinkSubmit}>
            <div className="form-group">
              <label>Title/Topic:</label>
              <input
                type="text"
                value={courseLink.title}
                onChange={(e) => setCourseLink({...courseLink, title: e.target.value})}
                placeholder="e.g., Math Chapter 5 Video"
                required
              />
            </div>
            <div className="form-group">
              <label>Description:</label>
              <textarea
                value={courseLink.description}
                onChange={(e) => setCourseLink({...courseLink, description: e.target.value})}
                placeholder="Brief description of the content"
                rows="2"
              />
            </div>
            <div className="form-group">
              <label>Resource Link:</label>
              <input
                type="url"
                value={courseLink.resourceLink}
                onChange={(e) => setCourseLink({...courseLink, resourceLink: e.target.value})}
                placeholder="https://drive.google.com/..."
                required
              />
            </div>
            <div className="form-group">
              <label>Content Type:</label>
              <select
                value={courseLink.linkType}
                onChange={(e) => setCourseLink({...courseLink, linkType: e.target.value})}
              >
                <option value="video">Video</option>
                <option value="document">Document</option>
                <option value="presentation">Presentation</option>
                <option value="website">Website</option>
                <option value="other">Other</option>
              </select>
            </div>
            <button type="submit" className="btn">Add Additional Link</button>
          </form>
          <small style={{ color: '#666', fontSize: '12px' }}>These are additional links separate from the main Complete Course link</small>
          
          <div style={{ marginTop: '20px' }}>
            <h4>Additional Course Links:</h4>
            {Array.isArray(existingCourseLinks) && existingCourseLinks.filter(link => link.title !== 'Complete Course').length > 0 ? (
              (Array.isArray(existingCourseLinks) ? existingCourseLinks : []).filter(link => link.title !== 'Complete Course').map(link => (
                <div key={link._id} style={{ padding: '8px', background: '#fff3cd', borderRadius: '4px', marginBottom: '8px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div style={{ flex: 1 }}>
                      <p><strong>{link.title}</strong> ({link.linkType})</p>
                      <p>{link.description}</p>
                      <a href={link.resourceLink} target="_blank" rel="noopener noreferrer" style={{ fontSize: '12px', color: '#007bff' }}>View Link</a>
                      <br/><small>Added: {new Date(link.createdAt).toLocaleDateString()}</small>
                    </div>
                    <div style={{ display: 'flex', gap: '5px', marginLeft: '10px' }}>
                      <button 
                        className="btn" 
                        style={{ background: '#007bff', fontSize: '12px', padding: '4px 8px' }}
                        onClick={() => editCourseLink(link)}
                      >
                        Edit
                      </button>
                      <button 
                        className="btn" 
                        style={{ background: '#dc3545', fontSize: '12px', padding: '4px 8px' }}
                        onClick={() => deleteCourseLink(link._id)}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p style={{ color: '#666', fontStyle: 'italic' }}>No additional course links added yet</p>
            )}
          </div>
        </div>
        )}

        {activeSection === 'library' && (
        <div id="library" className="card">
          <h3>📚 Digital Library</h3>
          <div style={{ marginBottom: '15px' }}>
            <p>Manage educational resources and links for all classes</p>
            <div style={{ padding: '8px', background: '#e3f2fd', borderRadius: '4px', marginBottom: '8px' }}>
              <strong>Quick Access:</strong>
              <p>📖 Study Materials | 🎥 Video Lectures | 📄 Documents</p>
            </div>
          </div>
          <button className="btn" onClick={() => setShowLibraryModal(true)}>📚 Add to Library</button>
          <button className="btn" onClick={() => alert('Library browser opened!')}>Browse Library</button>
          
          <div style={{ marginTop: '20px' }}>
            <h4>My Library Links:</h4>
            {libraryLinks.length > 0 ? (
              libraryLinks.map(link => (
                <div key={link._id} style={{ padding: '8px', background: '#e3f2fd', borderRadius: '4px', marginBottom: '8px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div style={{ flex: 1 }}>
                      <p><strong>{link.title}</strong> (Class: {link.class})</p>
                      <p>{link.description}</p>
                      <a href={link.resourceLink} target="_blank" rel="noopener noreferrer" style={{ fontSize: '12px', color: '#007bff' }}>View Resource</a>
                      <br/><small>Added: {new Date(link.createdAt).toLocaleDateString()}</small>
                    </div>
                    <div style={{ display: 'flex', gap: '5px', marginLeft: '10px' }}>
                      <button 
                        className="btn" 
                        style={{ background: '#007bff', fontSize: '12px', padding: '4px 8px' }}
                        onClick={() => editLibraryLink(link)}
                      >
                        Edit
                      </button>
                      <button 
                        className="btn" 
                        style={{ background: '#dc3545', fontSize: '12px', padding: '4px 8px' }}
                        onClick={() => deleteLibraryLink(link._id)}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p style={{ color: '#666', fontStyle: 'italic' }}>No library links added yet</p>
            )}
          </div>
        </div>
        )}

        {activeSection === 'classrank' && (
        <div id="classrank" className="card">
          <h3>🏆 Class Rank Management</h3>
          <div style={{ marginBottom: '15px' }}>
            <p>Assign class ranks to your students based on their performance</p>
            <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
              {students.map((student, index) => (
                <div key={student._id} style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center', 
                  padding: '8px', 
                  background: '#f8f9fa', 
                  borderRadius: '4px', 
                  marginBottom: '8px' 
                }}>
                  <div>
                    <strong>{student.name}</strong>
                    <p style={{ margin: '2px 0', fontSize: '12px', color: '#666' }}>
                      Current Rank: {student.classRank || 'Not Assigned'}
                    </p>
                  </div>
                  <select 
                    value={student.classRank || ''}
                    onChange={async (e) => {
                      try {
                        await axios.put(`${API_BASE_URL}/api/users/${student._id}`, { classRank: e.target.value });
                        fetchStudents();
                        alert(`Rank updated for ${student.name}`);
                      } catch (error) {
                        console.error('Error updating rank:', error);
                        alert('Error updating rank');
                      }
                    }}
                    style={{ padding: '4px', fontSize: '12px', borderRadius: '4px' }}
                  >
                    <option value="">Select Rank</option>
                    <option value="1st">1st</option>
                    <option value="2nd">2nd</option>
                    <option value="3rd">3rd</option>
                    <option value="4th">4th</option>
                    <option value="5th">5th</option>
                    <option value="6th">6th</option>
                    <option value="7th">7th</option>
                    <option value="8th">8th</option>
                    <option value="9th">9th</option>
                    <option value="10th">10th</option>
                  </select>
                </div>
              ))}
            </div>
          </div>
          <button 
            className="btn" 
            onClick={() => {
              const confirmation = window.confirm('This will clear all class ranks. Are you sure?');
              if (confirmation) {
                students.forEach(async (student) => {
                  try {
                    await axios.put(`${API_BASE_URL}/api/users/${student._id}`, { classRank: null });
                  } catch (error) {
                    console.error('Error clearing rank:', error);
                  }
                });
                fetchStudents();
                alert('All ranks cleared successfully!');
              }
            }}
            style={{ background: '#dc3545', marginRight: '10px' }}
          >
            Clear All Ranks
          </button>
        </div>
        )}

        {activeSection === 'games' && (
        <div id="games" className="card" style={{ gridColumn: 'span 2' }}>
          <GamesManager userRole={user.role} userClass={user.class} userName={user.name || user.email} />
        </div>
        )}

        {activeSection === 'qpbuilder' && (
        <QuestionPaperBuilder user={user} isPrincipal={false} onClose={() => setShowHome(true)} />
        )}

        {activeSection === 'printmarksheet' && (
        <div id="printmarksheet" className="card" style={{ gridColumn: 'span 2' }}>
          <PrintableMarksheet user={user} />
        </div>
        )}

        {activeSection === 'professionalmarksheet' && (
        <div id="professionalmarksheet" className="card" style={{ gridColumn: 'span 2' }}>
          <ProfessionalMarksheet user={user} />
        </div>
        )}

        {activeSection === 'visibility' && (
        <div id="visibility" className="card">
          <h3>👁️ Daily P/A Indicators</h3>
          <div style={{ marginBottom: '15px' }}>
            <p>Control whether students can see "P" and "A" indicators on calendar days.</p>
            <div style={{ padding: '10px', background: attendanceVisibility ? '#e8f5e8' : '#ffebee', borderRadius: '6px', marginBottom: '10px' }}>
              <strong>Calendar Indicators: </strong>
              <span style={{ color: attendanceVisibility ? '#2e7d32' : '#c62828' }}>
                {attendanceVisibility ? '✅ P/A indicators visible on calendar' : '❌ P/A indicators hidden on calendar'}
              </span>
            </div>
            <p style={{ fontSize: '12px', color: '#666', fontStyle: 'italic' }}>Note: Attendance summary will always remain visible to students.</p>
          </div>
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            <button 
              onClick={() => updateAttendanceVisibility(true)}
              disabled={attendanceVisibility === true}
              style={{ 
                background: attendanceVisibility === true ? '#6c757d' : '#4caf50', 
                color: 'white', 
                border: 'none', 
                padding: '8px 16px', 
                borderRadius: '6px', 
                cursor: attendanceVisibility === true ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: 'bold'
              }}
            >
              👁️ Show P/A
            </button>
            <button 
              onClick={() => updateAttendanceVisibility(false)}
              disabled={attendanceVisibility === false}
              style={{ 
                background: attendanceVisibility === false ? '#6c757d' : '#f44336', 
                color: 'white', 
                border: 'none', 
                padding: '8px 16px', 
                borderRadius: '6px', 
                cursor: attendanceVisibility === false ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: 'bold'
              }}
            >
              🚫 Hide P/A
            </button>
          </div>
        </div>
        )}



      </div>

      {showProfile && selectedStudent && (
        <div className="mobile-popup-overlay" style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999, padding: '10px' }}>
          <div className="mobile-popup-content" style={{ background: 'white', padding: '20px', borderRadius: '12px', width: '100%', maxWidth: '600px', maxHeight: '90vh', overflowY: 'auto', position: 'relative', margin: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h2>Student Profile: {editMode ? editedStudent.name : selectedStudent.name}</h2>
              <div style={{ display: 'flex', gap: '10px' }}>
                {!editMode ? (
                  <button onClick={() => setEditMode(true)} style={{ background: '#007bff', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}>✏️ Edit Profile</button>
                ) : (
                  <>
                    <button onClick={saveStudentProfile} style={{ background: '#28a745', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '5px', cursor: 'pointer' }}>💾 Save</button>
                    <button onClick={() => { setEditMode(false); setEditedStudent({...selectedStudent}); }} style={{ background: '#6c757d', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '5px', cursor: 'pointer' }}>❌ Cancel</button>
                  </>
                )}
                <button onClick={closeProfile} style={{ background: '#dc3545', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '5px', cursor: 'pointer' }}>✕</button>
              </div>
            </div>
            
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
              <div>
                <h4>Personal Information</h4>
                {editMode ? (
                  <div>
                    <div style={{ marginBottom: '10px' }}>
                      <label><strong>Name:</strong></label>
                      <input 
                        type="text" 
                        value={editedStudent.name || ''} 
                        onChange={(e) => setEditedStudent({...editedStudent, name: e.target.value})}
                        style={{ width: '100%', padding: '5px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px' }}
                      />
                    </div>
                    <div style={{ marginBottom: '10px' }}>
                      <label><strong>Email:</strong></label>
                      <input 
                        type="email" 
                        value={editedStudent.email || ''} 
                        onChange={(e) => setEditedStudent({...editedStudent, email: e.target.value})}
                        style={{ width: '100%', padding: '5px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px' }}
                      />
                    </div>
                    <div style={{ marginBottom: '10px' }}>
                      <label><strong>Class:</strong></label>
                      <input 
                        type="text" 
                        value={editedStudent.class || ''} 
                        onChange={(e) => setEditedStudent({...editedStudent, class: e.target.value})}
                        style={{ width: '100%', padding: '5px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px' }}
                      />
                    </div>
                    <div style={{ marginBottom: '10px' }}>
                      <label><strong>Father's Name:</strong></label>
                      <input 
                        type="text" 
                        value={editedStudent.fathersName || ''} 
                        onChange={(e) => setEditedStudent({...editedStudent, fathersName: e.target.value})}
                        style={{ width: '100%', padding: '5px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px' }}
                      />
                    </div>
                    <div style={{ marginBottom: '10px' }}>
                      <label><strong>Student SR:</strong></label>
                      <input 
                        type="text" 
                        value={editedStudent.studentId || ''} 
                        onChange={(e) => setEditedStudent({...editedStudent, studentId: e.target.value})}
                        style={{ width: '100%', padding: '5px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px' }}
                      />
                    </div>
                    {[
                      ['section', 'Section', 'text'],
                      ['rollNumber', 'Roll Number', 'text'],
                      ['phone', 'Phone Number', 'tel'],
                      ['mobile', 'Mobile', 'tel'],
                      ['mothersName', "Mother's Name", 'text'],
                      ['dateOfBirth', 'Date of Birth', 'date'],
                      ['gender', 'Gender', 'text'],
                      ['bloodGroup', 'Blood Group', 'text'],
                      ['address', 'Address', 'text']
                    ].map(([key, label, type]) => (
                      <div key={key} style={{ marginBottom: '10px' }}>
                        <label><strong>{label}:</strong></label>
                        <input
                          type={type}
                          value={editedStudent[key] || ''}
                          onChange={(e) => setEditedStudent({...editedStudent, [key]: e.target.value})}
                          style={{ width: '100%', padding: '5px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px' }}
                        />
                      </div>
                    ))}
                  </div>
                ) : (
                  <div>
                    <p><strong>Name:</strong> {selectedStudent.name}</p>
                    <p><strong>Email:</strong> {selectedStudent.email}</p>
                    <p><strong>Class:</strong> {selectedStudent.class}</p>
                    <p><strong>Section:</strong> {selectedStudent.section || 'N/A'}</p>
                    <p><strong>Roll Number:</strong> {selectedStudent.rollNumber || 'N/A'}</p>
                    <p><strong>Phone:</strong> {selectedStudent.phone || selectedStudent.mobile || 'N/A'}</p>
                    <p><strong>Mother's Name:</strong> {selectedStudent.mothersName || 'N/A'}</p>
                    <p><strong>Date of Birth:</strong> {selectedStudent.dateOfBirth || 'N/A'}</p>
                    <p><strong>Gender:</strong> {selectedStudent.gender || 'N/A'}</p>
                    <p><strong>Blood Group:</strong> {selectedStudent.bloodGroup || 'N/A'}</p>
                    <p><strong>Address:</strong> {selectedStudent.address || 'N/A'}</p>
                    <p><strong>Father's Name:</strong> {selectedStudent.fathersName || 'N/A'}</p>
                    <p><strong>Student SR:</strong> {selectedStudent.studentId || selectedStudent._id.slice(-6)}</p>
                  </div>
                )}
              </div>
              
              <div>
                <h4>Academic Performance</h4>
                {editMode ? (
                  <div>
                    <div style={{ marginBottom: '8px' }}>
                      <label><strong>Overall Grade:</strong></label>
                      <input type="text" value={editedStudent.overallGrade || ''} onChange={(e) => setEditedStudent({...editedStudent, overallGrade: e.target.value})} style={{ width: '100%', padding: '4px', marginTop: '2px', border: '1px solid #ddd', borderRadius: '3px' }} />
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                      <label><strong>Math:</strong></label>
                      <input type="text" value={editedStudent.mathGrade || ''} onChange={(e) => setEditedStudent({...editedStudent, mathGrade: e.target.value})} style={{ width: '100%', padding: '4px', marginTop: '2px', border: '1px solid #ddd', borderRadius: '3px' }} />
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                      <label><strong>Science:</strong></label>
                      <input type="text" value={editedStudent.scienceGrade || ''} onChange={(e) => setEditedStudent({...editedStudent, scienceGrade: e.target.value})} style={{ width: '100%', padding: '4px', marginTop: '2px', border: '1px solid #ddd', borderRadius: '3px' }} />
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                      <label><strong>English:</strong></label>
                      <input type="text" value={editedStudent.englishGrade || ''} onChange={(e) => setEditedStudent({...editedStudent, englishGrade: e.target.value})} style={{ width: '100%', padding: '4px', marginTop: '2px', border: '1px solid #ddd', borderRadius: '3px' }} />
                    </div>
                  </div>
                ) : (
                  <div>
                    <p><strong>Overall Grade:</strong> {selectedStudent.overallGrade || 'B+ (85%)'}</p>
                    <p><strong>Math:</strong> {selectedStudent.mathGrade || '88% (A-)'}</p>
                    <p><strong>Science:</strong> {selectedStudent.scienceGrade || '82% (B+)'}</p>
                    <p><strong>English:</strong> {selectedStudent.englishGrade || '85% (B+)'}</p>
                  </div>
                )}
              </div>
              
              <div>
                <h4>Attendance Record</h4>
                {editMode ? (
                  <div>
                    <div style={{ marginBottom: '8px' }}>
                      <label><strong>Total Days:</strong></label>
                      <input type="text" value={editedStudent.totalDays || ''} onChange={(e) => setEditedStudent({...editedStudent, totalDays: e.target.value})} style={{ width: '100%', padding: '4px', marginTop: '2px', border: '1px solid #ddd', borderRadius: '3px' }} />
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                      <label><strong>Present Days:</strong></label>
                      <input type="text" value={editedStudent.presentDays || ''} onChange={(e) => setEditedStudent({...editedStudent, presentDays: e.target.value})} style={{ width: '100%', padding: '4px', marginTop: '2px', border: '1px solid #ddd', borderRadius: '3px' }} />
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                      <label><strong>Absent Days:</strong></label>
                      <input type="text" value={editedStudent.absentDays || ''} onChange={(e) => setEditedStudent({...editedStudent, absentDays: e.target.value})} style={{ width: '100%', padding: '4px', marginTop: '2px', border: '1px solid #ddd', borderRadius: '3px' }} />
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                      <label><strong>Late Days:</strong></label>
                      <input type="text" value={editedStudent.lateDays || ''} onChange={(e) => setEditedStudent({...editedStudent, lateDays: e.target.value})} style={{ width: '100%', padding: '4px', marginTop: '2px', border: '1px solid #ddd', borderRadius: '3px' }} />
                    </div>
                  </div>
                ) : (
                  <div>
                    <p><strong>Total Days:</strong> {selectedStudent.totalDays || '180'}</p>
                    <p><strong>Present:</strong> {selectedStudent.presentDays || '165 days (92%)'}</p>
                    <p><strong>Absent:</strong> {selectedStudent.absentDays || '12'} days</p>
                    <p><strong>Late:</strong> {selectedStudent.lateDays || '3'} days</p>
                  </div>
                )}
              </div>
              
              <div>
                <h4>Discipline Record</h4>
                {editMode ? (
                  <div>
                    <div style={{ marginBottom: '8px' }}>
                      <label><strong>Behavior Score:</strong></label>
                      <input type="text" value={editedStudent.behaviorScore || ''} onChange={(e) => setEditedStudent({...editedStudent, behaviorScore: e.target.value})} style={{ width: '100%', padding: '4px', marginTop: '2px', border: '1px solid #ddd', borderRadius: '3px' }} />
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                      <label><strong>Warnings:</strong></label>
                      <input type="text" value={editedStudent.warnings || ''} onChange={(e) => setEditedStudent({...editedStudent, warnings: e.target.value})} style={{ width: '100%', padding: '4px', marginTop: '2px', border: '1px solid #ddd', borderRadius: '3px' }} />
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                      <label><strong>Violations:</strong></label>
                      <input type="text" value={editedStudent.violations || ''} onChange={(e) => setEditedStudent({...editedStudent, violations: e.target.value})} style={{ width: '100%', padding: '4px', marginTop: '2px', border: '1px solid #ddd', borderRadius: '3px' }} />
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                      <label><strong>Commendations:</strong></label>
                      <input type="text" value={editedStudent.commendations || ''} onChange={(e) => setEditedStudent({...editedStudent, commendations: e.target.value})} style={{ width: '100%', padding: '4px', marginTop: '2px', border: '1px solid #ddd', borderRadius: '3px' }} />
                    </div>
                  </div>
                ) : (
                  <div>
                    <p><strong>Behavior Score:</strong> {selectedStudent.behaviorScore || '95/100'}</p>
                    <p><strong>Warnings:</strong> {selectedStudent.warnings || '1'}</p>
                    <p><strong>Violations:</strong> {selectedStudent.violations || '0'}</p>
                    <p><strong>Commendations:</strong> {selectedStudent.commendations || '3'}</p>
                  </div>
                )}
              </div>
              
              <div>
                <h4>Assignment Status</h4>
                {editMode ? (
                  <div>
                    <div style={{ marginBottom: '8px' }}>
                      <label><strong>Completed:</strong></label>
                      <input type="text" value={editedStudent.completedAssignments || ''} onChange={(e) => setEditedStudent({...editedStudent, completedAssignments: e.target.value})} style={{ width: '100%', padding: '4px', marginTop: '2px', border: '1px solid #ddd', borderRadius: '3px' }} />
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                      <label><strong>On Time:</strong></label>
                      <input type="text" value={editedStudent.onTimeSubmissions || ''} onChange={(e) => setEditedStudent({...editedStudent, onTimeSubmissions: e.target.value})} style={{ width: '100%', padding: '4px', marginTop: '2px', border: '1px solid #ddd', borderRadius: '3px' }} />
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                      <label><strong>Late Submissions:</strong></label>
                      <input type="text" value={editedStudent.lateSubmissions || ''} onChange={(e) => setEditedStudent({...editedStudent, lateSubmissions: e.target.value})} style={{ width: '100%', padding: '4px', marginTop: '2px', border: '1px solid #ddd', borderRadius: '3px' }} />
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                      <label><strong>Missing:</strong></label>
                      <input type="text" value={editedStudent.missingAssignments || ''} onChange={(e) => setEditedStudent({...editedStudent, missingAssignments: e.target.value})} style={{ width: '100%', padding: '4px', marginTop: '2px', border: '1px solid #ddd', borderRadius: '3px' }} />
                    </div>
                  </div>
                ) : (
                  <div>
                    <p><strong>Completed:</strong> {selectedStudent.completedAssignments || '28/30 (93%)'}</p>
                    <p><strong>On Time:</strong> {selectedStudent.onTimeSubmissions || '26/28 (93%)'}</p>
                    <p><strong>Late Submissions:</strong> {selectedStudent.lateSubmissions || '2'}</p>
                    <p><strong>Missing:</strong> {selectedStudent.missingAssignments || '2'}</p>
                  </div>
                )}
              </div>
              
              <div>
                <h4>Parent Contact</h4>
                {editMode ? (
                  <div>
                    <div style={{ marginBottom: '8px' }}>
                      <label><strong>Guardian:</strong></label>
                      <input type="text" value={editedStudent.guardianName || ''} onChange={(e) => setEditedStudent({...editedStudent, guardianName: e.target.value})} style={{ width: '100%', padding: '4px', marginTop: '2px', border: '1px solid #ddd', borderRadius: '3px' }} />
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                      <label><strong>Phone:</strong></label>
                      <input type="tel" value={editedStudent.guardianPhone || ''} onChange={(e) => setEditedStudent({...editedStudent, guardianPhone: e.target.value})} style={{ width: '100%', padding: '4px', marginTop: '2px', border: '1px solid #ddd', borderRadius: '3px' }} />
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                      <label><strong>Email:</strong></label>
                      <input type="email" value={editedStudent.guardianEmail || ''} onChange={(e) => setEditedStudent({...editedStudent, guardianEmail: e.target.value})} style={{ width: '100%', padding: '4px', marginTop: '2px', border: '1px solid #ddd', borderRadius: '3px' }} />
                    </div>
                    <div style={{ marginBottom: '8px' }}>
                      <label><strong>Last Contact:</strong></label>
                      <input type="text" value={editedStudent.lastContact || ''} onChange={(e) => setEditedStudent({...editedStudent, lastContact: e.target.value})} style={{ width: '100%', padding: '4px', marginTop: '2px', border: '1px solid #ddd', borderRadius: '3px' }} />
                    </div>
                  </div>
                ) : (
                  <div>
                    <p><strong>Guardian:</strong> {selectedStudent.guardianName || 'Mr. & Mrs. Parent'}</p>
                    <p><strong>Phone:</strong> {selectedStudent.guardianPhone || '+1-234-567-8900'}</p>
                    <p><strong>Email:</strong> {selectedStudent.guardianEmail || 'parent@email.com'}</p>
                    <p><strong>Last Contact:</strong> {selectedStudent.lastContact || 'March 10, 2024'}</p>
                  </div>
                )}
              </div>
            </div>
            
            <div style={{ marginTop: '20px' }}>
              <h4>Recent Activity</h4>
              <div style={{ background: '#f8f9fa', padding: '10px', borderRadius: '5px', fontSize: '14px' }}>
                <p>• Submitted Math Assignment - March 15</p>
                <p>• Absent on March 12 (Medical)</p>
                <p>• Excellent performance in Science Quiz - March 10</p>
                <p>• Parent meeting scheduled - March 20</p>
              </div>
            </div>
            
            <div style={{ marginTop: '20px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              <button 
                className="btn" 
                style={{ background: '#25d366', color: 'white' }}
                onClick={() => {
                  setSelectedStudentForWhatsApp(selectedStudent);
                  setShowWhatsAppMessenger(true);
                }}
              >
                📱 WhatsApp Parent
              </button>
              <button 
                onClick={() => impersonateStudent(selectedStudent)}
                style={{ 
                  background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)', 
                  color: 'white', 
                  border: 'none', 
                  padding: '10px 20px', 
                  borderRadius: '6px', 
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  boxShadow: '0 4px 15px rgba(139, 92, 246, 0.3)'
                }}
              >
                🚪 Access Student Account
              </button>
              <button className="btn">Schedule Meeting</button>
              <button className="btn">Add Note</button>
            </div>
          </div>
        </div>
      )}

      {showLibraryModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.6)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 5000 }}>
          <div style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', padding: '0', borderRadius: '15px', width: '90%', maxWidth: '500px', boxShadow: '0 20px 40px rgba(0,0,0,0.3)', overflow: 'hidden' }}>
            <div style={{ background: 'rgba(255,255,255,0.95)', margin: '3px', borderRadius: '12px', padding: '30px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px' }}>
                <div>
                  <h2 style={{ margin: 0, color: '#333', fontSize: '24px', fontWeight: 'bold' }}>📚 Digital Library</h2>
                  <p style={{ margin: '5px 0 0 0', color: '#666', fontSize: '14px' }}>Add educational resources for students</p>
                </div>
                <button 
                  onClick={() => setShowLibraryModal(false)} 
                  style={{ 
                    background: 'linear-gradient(45deg, #ff6b6b, #ee5a52)', 
                    color: 'white', 
                    border: 'none', 
                    padding: '8px 12px', 
                    borderRadius: '50%', 
                    cursor: 'pointer',
                    fontSize: '16px',
                    width: '40px',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  ✕
                </button>
              </div>
              
              <form onSubmit={handleLibrarySubmit}>
                <div style={{ marginBottom: '20px' }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#555' }}>📖 Resource Title:</label>
                  <input
                    type="text"
                    value={libraryLink.title}
                    onChange={(e) => setLibraryLink({...libraryLink, title: e.target.value})}
                    placeholder="e.g., Mathematics Chapter 5 - Advanced Algebra"
                    required
                    style={{ 
                      width: '100%', 
                      padding: '12px', 
                      border: '2px solid #e1e5e9', 
                      borderRadius: '8px', 
                      fontSize: '14px',
                      outline: 'none'
                    }}
                  />
                </div>
                
                <div style={{ marginBottom: '20px' }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#555' }}>🎯 Target Class:</label>
                  <input
                    type="text"
                    value={user.class}
                    readOnly
                    style={{ 
                      width: '100%', 
                      padding: '12px', 
                      border: '2px solid #e1e5e9', 
                      borderRadius: '8px', 
                      fontSize: '14px',
                      background: '#f8f9fa',
                      color: '#666'
                    }}
                  />
                </div>
                
                <div style={{ marginBottom: '20px' }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#555' }}>🔗 Resource Link:</label>
                  <input
                    type="url"
                    value={libraryLink.resourceLink}
                    onChange={(e) => setLibraryLink({...libraryLink, resourceLink: e.target.value})}
                    placeholder="https://drive.google.com/... or https://youtube.com/..."
                    required
                    style={{ 
                      width: '100%', 
                      padding: '12px', 
                      border: '2px solid #e1e5e9', 
                      borderRadius: '8px', 
                      fontSize: '14px'
                    }}
                  />
                </div>
                
                <div style={{ marginBottom: '25px' }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#555' }}>📝 Description (Optional):</label>
                  <textarea
                    value={libraryLink.description}
                    onChange={(e) => setLibraryLink({...libraryLink, description: e.target.value})}
                    placeholder="Brief description of the resource content..."
                    rows="3"
                    style={{ 
                      width: '100%', 
                      padding: '12px', 
                      border: '2px solid #e1e5e9', 
                      borderRadius: '8px', 
                      fontSize: '14px',
                      resize: 'vertical'
                    }}
                  />
                </div>
                
                <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end' }}>
                  <button 
                    type="button"
                    onClick={() => setShowLibraryModal(false)}
                    style={{ 
                      background: '#6c757d', 
                      color: 'white', 
                      border: 'none', 
                      padding: '12px 24px', 
                      borderRadius: '8px', 
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: 'bold'
                    }}
                  >
                    Cancel
                  </button>
                  <button 
                    type="submit"
                    style={{ 
                      background: 'linear-gradient(45deg, #667eea, #764ba2)', 
                      color: 'white', 
                      border: 'none', 
                      padding: '12px 24px', 
                      borderRadius: '8px', 
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)'
                    }}
                  >
                    📚 Add to Library
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {showMarksheetModal && selectedStudent && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center', alignItems: 'flex-start', zIndex: 5000, overflow: 'auto', padding: '10px' }}>
          <div style={{ background: 'white', borderRadius: '15px', width: '100%', maxWidth: '1200px', maxHeight: 'calc(100vh - 20px)', overflow: 'auto', boxShadow: '0 20px 40px rgba(0,0,0,0.3)', marginTop: '10px' }}>
            <div style={{ padding: '20px', borderBottom: '2px solid #f59e0b', background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)', borderRadius: '15px 15px 0 0' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <h2 style={{ margin: 0, color: '#92400e', fontSize: '24px', fontWeight: 'bold' }}>📋 Marksheet - {selectedStudent.name}</h2>
                  <p style={{ margin: '5px 0 0 0', color: '#92400e', fontSize: '16px' }}>Class {selectedStudent.class} - Enter Marks</p>
                </div>
                <button 
                  onClick={() => setShowMarksheetModal(false)} 
                  style={{ 
                    background: 'linear-gradient(45deg, #dc2626, #b91c1c)', 
                    color: 'white', 
                    border: 'none', 
                    padding: '10px 15px', 
                    borderRadius: '50%', 
                    cursor: 'pointer',
                    fontSize: '18px',
                    width: '45px',
                    height: '45px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  ✕
                </button>
              </div>
            </div>
            
            <div style={{ padding: '15px' }}>
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px', minWidth: '800px' }}>
                  <thead>
                    <tr style={{ background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)', color: 'white' }}>
                      <th style={{ padding: '8px 4px', border: '1px solid #ddd', textAlign: 'center' }}>Subject</th>
                      <th style={{ padding: '8px 4px', border: '1px solid #ddd', textAlign: 'center' }}>Term 1<br/>(10)</th>
                      <th style={{ padding: '8px 4px', border: '1px solid #ddd', textAlign: 'center' }}>Term 2<br/>(10)</th>
                      <th style={{ padding: '8px 4px', border: '1px solid #ddd', textAlign: 'center' }}>Half Yearly<br/>(80)</th>
                      <th style={{ padding: '8px 4px', border: '1px solid #ddd', textAlign: 'center' }}>Term 3<br/>(10)</th>
                      <th style={{ padding: '8px 4px', border: '1px solid #ddd', textAlign: 'center' }}>Project<br/>(10)</th>
                      <th style={{ padding: '8px 4px', border: '1px solid #ddd', textAlign: 'center' }}>Annual<br/>(80)</th>
                    </tr>
                  </thead>
                <tbody>
                  {getSubjectsForClass().map(subject => (
                    <tr key={subject}>
                      <td style={{ padding: '8px 4px', border: '1px solid #ddd', fontWeight: 'bold', textTransform: 'capitalize' }}>{getSubjectDisplayName(subject)}</td>
                      <td style={{ padding: '4px', border: '1px solid #ddd' }}>
                        <input 
                          type="number" 
                          value={marksheetData.term1?.[subject] || ''}
                          onChange={(e) => updateMarksheetField('term1', subject, e.target.value)}
                          style={{ width: '100%', padding: '4px', border: 'none', textAlign: 'center' }}
                          max="10"
                        />
                      </td>
                      <td style={{ padding: '4px', border: '1px solid #ddd' }}>
                        <input 
                          type="number" 
                          value={marksheetData.term2?.[subject] || ''}
                          onChange={(e) => updateMarksheetField('term2', subject, e.target.value)}
                          style={{ width: '100%', padding: '4px', border: 'none', textAlign: 'center' }}
                          max="10"
                        />
                      </td>
                      <td style={{ padding: '4px', border: '1px solid #ddd' }}>
                        <input 
                          type="number" 
                          value={marksheetData.halfYearly?.[subject] || ''}
                          onChange={(e) => updateMarksheetField('halfYearly', subject, e.target.value)}
                          style={{ width: '100%', padding: '4px', border: 'none', textAlign: 'center' }}
                          max="80"
                        />
                      </td>
                      <td style={{ padding: '4px', border: '1px solid #ddd' }}>
                        <input 
                          type="number" 
                          value={marksheetData.term3?.[subject] || ''}
                          onChange={(e) => updateMarksheetField('term3', subject, e.target.value)}
                          style={{ width: '100%', padding: '4px', border: 'none', textAlign: 'center' }}
                          max="10"
                        />
                      </td>
                      <td style={{ padding: '4px', border: '1px solid #ddd' }}>
                        <input 
                          type="number" 
                          value={marksheetData.project?.[subject] || ''}
                          onChange={(e) => updateMarksheetField('project', subject, e.target.value)}
                          style={{ width: '100%', padding: '4px', border: 'none', textAlign: 'center' }}
                          max="10"
                        />
                      </td>
                      <td style={{ padding: '4px', border: '1px solid #ddd' }}>
                        <input 
                          type="number" 
                          value={marksheetData.annualExam?.[subject] || ''}
                          onChange={(e) => updateMarksheetField('annualExam', subject, e.target.value)}
                          style={{ width: '100%', padding: '4px', border: 'none', textAlign: 'center' }}
                          max="80"
                        />
                      </td>
                    </tr>
                  ))}
                  </tbody>
                </table>
              </div>
              
              <div style={{ marginTop: '15px', padding: '10px', background: '#f0f8ff', borderRadius: '8px' }}>
                <h4 style={{ margin: '0 0 10px 0', color: '#3b82f6' }}>Term Percentages:</h4>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: '8px', fontSize: '12px' }}>
                  {['term1', 'term2', 'halfYearly', 'term3', 'project', 'annualExam'].map(term => {
                    const allSubjects = getSubjectsForClass(selectedStudent?.class);
                    const subjects = (term === 'halfYearly' || term === 'annualExam') ? allSubjects : allSubjects.slice(0, 4);
                    const totalObtained = subjects.reduce((sum, subject) => sum + (parseInt(marksheetData[term]?.[subject]) || 0), 0);
                    const totalPossible = subjects.reduce((sum, subject) => {
                      // For Class 8th, all subjects have same weightage
                      if (selectedStudent?.class === '8th' || selectedStudent?.class === '8') {
                        return sum + (term === 'halfYearly' || term === 'annualExam' ? 80 : 10);
                      }
                      // For other classes, maintain original logic
                      if (subject === 'gk' || subject === 'computer') {
                        return sum + (term === 'halfYearly' || term === 'annualExam' ? 80 : 10);
                      }
                      return sum + (term === 'halfYearly' || term === 'annualExam' ? 80 : 10);
                    }, 0);
                    const percentage = totalPossible > 0 ? ((totalObtained / totalPossible) * 100).toFixed(1) : '0.0';
                    return (
                      <div key={term} style={{ padding: '5px', background: 'white', borderRadius: '4px', textAlign: 'center' }}>
                        <strong>{term.replace(/([A-Z])/g, ' $1').toUpperCase()}</strong><br/>
                        {percentage}%
                      </div>
                    );
                  })}
                </div>
              </div>

              <div style={{ marginTop: '20px', padding: '15px', background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)', borderRadius: '12px', border: '2px solid #2196f3' }}>
                <h4 style={{ margin: '0 0 15px 0', color: '#1565c0', textAlign: 'center' }}>👁️ Result Visibility Control</h4>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '10px', marginBottom: '15px' }}>
                  {['term1', 'term2', 'halfYearly', 'term3', 'project', 'annualExam'].map(exam => (
                    <label key={exam} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px', background: 'rgba(255,255,255,0.7)', borderRadius: '8px', cursor: 'pointer' }}>
                      <input 
                        type="checkbox" 
                        checked={marksheetData.visibility?.[exam] || false}
                        onChange={(e) => {
                          setMarksheetData(prev => ({
                            ...prev,
                            visibility: {
                              ...prev.visibility,
                              [exam]: e.target.checked
                            }
                          }));
                        }}
                        style={{ transform: 'scale(1.2)' }}
                      />
                      <span style={{ fontWeight: '600', color: '#1565c0', fontSize: '13px', textTransform: 'capitalize' }}>
                        {exam.replace(/([A-Z])/g, ' $1')}
                      </span>
                    </label>
                  ))}
                </div>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px', background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)', borderRadius: '8px', cursor: 'pointer', justifyContent: 'center' }}>
                  <input 
                    type="checkbox" 
                    checked={marksheetData.visibility?.finalResult || false}
                    onChange={(e) => {
                      setMarksheetData(prev => ({
                        ...prev,
                        visibility: {
                          ...prev.visibility,
                          finalResult: e.target.checked
                        }
                      }));
                    }}
                    style={{ transform: 'scale(1.3)' }}
                  />
                  <span style={{ fontWeight: '700', color: 'white', fontSize: '14px' }}>
                    🏆 Show Final Result & Division
                  </span>
                </label>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px', marginTop: '20px' }}>
                <div>
                  <h4>Co-Curricular Activities (Annual)</h4>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: '10px' }}>
                    <div>
                      <label>Drawing:</label>
                      <select 
                        value={marksheetData.annualExam?.drawing || ''}
                        onChange={(e) => updateMarksheetField('annualExam', 'drawing', e.target.value)}
                        style={{ width: '100%', padding: '4px' }}
                      >
                        <option value="">Select</option>
                        <option value="A+">A+</option>
                        <option value="A">A</option>
                        <option value="B">B</option>
                        <option value="C">C</option>
                      </select>
                    </div>
                    <div>
                      <label>Discipline:</label>
                      <select 
                        value={marksheetData.annualExam?.discipline || ''}
                        onChange={(e) => updateMarksheetField('annualExam', 'discipline', e.target.value)}
                        style={{ width: '100%', padding: '4px' }}
                      >
                        <option value="">Select</option>
                        <option value="A+">A+</option>
                        <option value="A">A</option>
                        <option value="B">B</option>
                        <option value="C">C</option>
                      </select>
                    </div>
                    <div>
                      <label>Neatness:</label>
                      <select 
                        value={marksheetData.annualExam?.neatness || ''}
                        onChange={(e) => updateMarksheetField('annualExam', 'neatness', e.target.value)}
                        style={{ width: '100%', padding: '4px' }}
                      >
                        <option value="">Select</option>
                        <option value="A+">A+</option>
                        <option value="A">A</option>
                        <option value="B">B</option>
                        <option value="C">C</option>
                      </select>
                    </div>
                    <div>
                      <label>Attendance:</label>
                      <input 
                        type="text" 
                        value={marksheetData.annualExam?.attendance || ''}
                        onChange={(e) => updateMarksheetField('annualExam', 'attendance', e.target.value)}
                        placeholder="e.g., 85.5%"
                        style={{ width: '100%', padding: '4px' }}
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <h4>Parent Meeting Status</h4>
                  {['term1', 'term2', 'halfYearly', 'term3', 'project', 'annualExam'].map(exam => (
                    <div key={exam} style={{ marginBottom: '8px' }}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <input 
                          type="checkbox" 
                          checked={marksheetData[exam]?.parentsAttainedPTM || false}
                          onChange={(e) => updateMarksheetField(exam, 'parentsAttainedPTM', e.target.checked)}
                        />
                        <span style={{ textTransform: 'capitalize' }}>{exam} PTM</span>
                      </label>
                    </div>
                  ))}
                </div>
              </div>

              <div style={{ textAlign: 'center', marginTop: '20px' }}>
                <button 
                  onClick={saveMarksheet}
                  style={{ 
                    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', 
                    color: 'white', 
                    border: 'none', 
                    padding: '12px 30px', 
                    borderRadius: '8px', 
                    cursor: 'pointer',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    boxShadow: '0 4px 15px rgba(16, 185, 129, 0.3)'
                  }}
                >
                  💾 Save Marksheet
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showIdCardModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center', alignItems: 'flex-start', zIndex: 5000, overflowY: 'auto', padding: '20px 0' }}>
          <div style={{ background: 'white', borderRadius: '15px', padding: '20px', boxShadow: '0 20px 40px rgba(0,0,0,0.3)', display: 'flex', flexDirection: 'column', alignItems: 'center', width: '90%', maxWidth: '500px', margin: '0 auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', width: '100%' }}>
              <h2 style={{ margin: 0, color: '#10b981', fontSize: '20px', fontWeight: 'bold' }}>🆔 ID Card - {selectedStudent.name}</h2>
              <button 
                onClick={() => setShowIdCardModal(false)} 
                style={{ 
                  background: '#dc2626', 
                  color: 'white', 
                  border: 'none', 
                  padding: '8px 12px', 
                  borderRadius: '50%', 
                  cursor: 'pointer',
                  fontSize: '16px'
                }}
              >
                ×
              </button>
            </div>
            
            {/* Professional ID Card Preview */}
            <div data-id-card style={{ 
              width: '350px', 
              height: '220px', 
              background: '#1e40af',
              borderRadius: '10px', 
              padding: '0',
              boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
              border: '2px solid #ffffff',
              position: 'relative',
              overflow: 'hidden',
              marginBottom: '20px'
            }}>
              {/* Header section */}
              <div style={{ 
                background: '#ffffff', 
                padding: '12px 15px', 
                borderRadius: '8px 8px 0 0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{
                    width: '40px',
                    height: '40px',
                    background: '#1e40af',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '20px',
                    color: 'white'
                  }}>
                    <img 
                      src="/logo.png" 
                      alt="School Logo" 
                      style={{
                        width: '30px',
                        height: '30px',
                        objectFit: 'contain'
                      }}
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.parentElement.innerHTML = '🏫';
                      }}
                    />
                  </div>
                  <div>
                    <h3 style={{ color: '#1e40af', margin: '0', fontSize: '16px', fontWeight: 'bold' }}>{localStorage.getItem('schoolName') || 'The Rising School'}</h3>
                    <p style={{ margin: '0', fontSize: '10px', color: '#64748b' }}>Student Identity Card</p>
                  </div>
                </div>
                <div style={{
                  background: '#dc2626',
                  color: 'white',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  fontSize: '10px',
                  fontWeight: 'bold'
                }}>2025-26</div>
              </div>
              
              {/* Main content */}
              <div style={{ padding: '15px', display: 'flex', gap: '15px', height: 'calc(100% - 64px)' }}>
                {/* Photo section */}
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <div style={{
                    width: '70px',
                    height: '85px',
                    background: selectedStudent?.profilePicture 
                      ? `url(${selectedStudent.profilePicture}) center/cover no-repeat` 
                      : '#f3f4f6',
                    border: '2px solid #ffffff',
                    borderRadius: '6px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px',
                    color: '#6b7280',
                    overflow: 'hidden',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  }}>
                    {!selectedStudent?.profilePicture && '👤'}
                  </div>
                  <div style={{
                    marginTop: '8px',
                    background: '#ffffff',
                    padding: '3px 8px',
                    borderRadius: '4px',
                    fontSize: '9px',
                    fontWeight: 'bold',
                    color: '#1e40af'
                  }}>ID: {idCardData.scholarNo || selectedStudent._id?.slice(-6)}</div>
                </div>
                
                {/* Info section */}
                <div style={{ flex: 1, color: 'white' }}>
                  <div style={{ marginBottom: '10px' }}>
                    <h4 style={{ 
                      margin: '0 0 2px 0', 
                      fontSize: '14px', 
                      fontWeight: 'bold', 
                      color: 'white'
                    }}>{selectedStudent.name}</h4>
                    <p style={{ 
                      margin: '0', 
                      fontSize: '11px', 
                      color: 'rgba(255,255,255,0.9)'
                    }}>Class: {selectedStudent.class}</p>
                  </div>
                  
                  <div style={{ fontSize: '10px', lineHeight: '1.4', color: 'rgba(255,255,255,0.95)' }}>
                    <div style={{ marginBottom: '3px' }}>
                      <span style={{ fontWeight: 'bold' }}>DOB: </span>
                      <span>{idCardData.dob ? new Date(idCardData.dob).toLocaleDateString('en-GB') : 'N/A'}</span>
                    </div>
                    <div style={{ marginBottom: '3px' }}>
                      <span style={{ fontWeight: 'bold' }}>Father: </span>
                      <span>{(idCardData.fathersName || 'N/A').length > 15 ? (idCardData.fathersName || 'N/A').substring(0, 15) + '...' : (idCardData.fathersName || 'N/A')}</span>
                    </div>
                    <div style={{ marginBottom: '3px' }}>
                      <span style={{ fontWeight: 'bold' }}>Mobile: </span>
                      <span>{idCardData.mobile || 'N/A'}</span>
                    </div>
                    <div>
                      <span style={{ fontWeight: 'bold' }}>Address: </span>
                      <span>{(idCardData.address || 'N/A').length > 20 ? (idCardData.address || 'N/A').substring(0, 20) + '...' : (idCardData.address || 'N/A')}</span>
                    </div>
                  </div>
                  
                  {/* Validity section */}
                  <div style={{
                    position: 'absolute',
                    bottom: '10px',
                    right: '15px',
                    background: 'rgba(255,255,255,0.2)',
                    padding: '4px 8px',
                    borderRadius: '4px'
                  }}>
                    <div style={{ fontSize: '8px', color: 'white', textAlign: 'center' }}>
                      <div>Valid Until</div>
                      <div>March 2026</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Form Fields */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', fontSize: '14px', width: '100%', maxWidth: '400px' }}>
              <div>
                <label>Date of Birth:</label>
                <input 
                  type="date" 
                  value={idCardData.dob || ''}
                  onChange={(e) => updateIdCardField('dob', e.target.value)}
                  style={{ width: '100%', padding: '6px', border: '1px solid #ddd', borderRadius: '4px' }}
                />
              </div>
              <div>
                <label>Scholar No:</label>
                <input 
                  type="text" 
                  value={idCardData.scholarNo || ''}
                  onChange={(e) => updateIdCardField('scholarNo', e.target.value)}
                  style={{ width: '100%', padding: '6px', border: '1px solid #ddd', borderRadius: '4px' }}
                />
              </div>
              <div>
                <label>Father's Name:</label>
                <input 
                  type="text" 
                  value={idCardData.fathersName || ''}
                  onChange={(e) => updateIdCardField('fathersName', e.target.value)}
                  style={{ width: '100%', padding: '6px', border: '1px solid #ddd', borderRadius: '4px' }}
                />
              </div>
              <div>
                <label>Mother's Name:</label>
                <input 
                  type="text" 
                  value={idCardData.mothersName || ''}
                  onChange={(e) => updateIdCardField('mothersName', e.target.value)}
                  style={{ width: '100%', padding: '6px', border: '1px solid #ddd', borderRadius: '4px' }}
                />
              </div>
              <div>
                <label>Mobile:</label>
                <input 
                  type="tel" 
                  value={idCardData.mobile || ''}
                  onChange={(e) => updateIdCardField('mobile', e.target.value)}
                  style={{ width: '100%', padding: '6px', border: '1px solid #ddd', borderRadius: '4px' }}
                />
              </div>
              <div style={{ gridColumn: 'span 2' }}>
                <label>Address:</label>
                <textarea 
                  value={idCardData.address || ''}
                  onChange={(e) => updateIdCardField('address', e.target.value)}
                  rows="3"
                  style={{ width: '100%', padding: '6px', border: '1px solid #ddd', borderRadius: '4px', resize: 'vertical' }}
                />
              </div>
            </div>

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '20px', flexWrap: 'wrap' }}>
              <button 
                onClick={saveIdCard}
                style={{ 
                  background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', 
                  color: 'white', 
                  border: 'none', 
                  padding: '10px 25px', 
                  borderRadius: '8px', 
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: 'bold'
                }}
              >
                💾 Save ID Card
              </button>
              <button 
                onClick={() => {
                  // Download ID card functionality for teachers
                  const canvas = document.createElement('canvas');
                  const ctx = canvas.getContext('2d');
                  
                  // Simple dimensions matching display (350x220 scaled up)
                  canvas.width = 1050; // 350 * 3
                  canvas.height = 660;  // 220 * 3
                  const scale = 3;
                  
                  // School settings
                  const schoolSettings = {
                    name: localStorage.getItem('schoolName') || 'The Rising School',
                    address: localStorage.getItem('schoolAddress') || 'Savina, Udaipur',
                    phone: localStorage.getItem('schoolPhone') || '8209683549'
                  };
                  
                  // Main blue background
                  ctx.fillStyle = '#1e40af';
                  ctx.fillRect(0, 0, canvas.width, canvas.height);
                  
                  // Rounded corners
                  ctx.globalCompositeOperation = 'destination-in';
                  ctx.beginPath();
                  ctx.roundRect(0, 0, canvas.width, canvas.height, 10 * scale);
                  ctx.fill();
                  ctx.globalCompositeOperation = 'source-over';
                  
                  // White border
                  ctx.strokeStyle = '#ffffff';
                  ctx.lineWidth = 6;
                  ctx.beginPath();
                  ctx.roundRect(3, 3, canvas.width-6, canvas.height-6, 7 * scale);
                  ctx.stroke();
                  
                  // Header section
                  const headerHeight = 64 * scale;
                  ctx.fillStyle = '#ffffff';
                  ctx.beginPath();
                  ctx.roundRect(0, 0, canvas.width, headerHeight, [8 * scale, 8 * scale, 0, 0]);
                  ctx.fill();
                  
                  // Logo area
                  const logoSize = 40 * scale;
                  const logoX = 15 * scale;
                  const logoY = 12 * scale;
                  ctx.fillStyle = '#1e40af';
                  ctx.beginPath();
                  ctx.roundRect(logoX, logoY, logoSize, logoSize, 8 * scale);
                  ctx.fill();
                  
                  // Try to load logo
                  const logoImg = new Image();
                  logoImg.crossOrigin = 'anonymous';
                  logoImg.onload = () => {
                    ctx.drawImage(logoImg, logoX + 5 * scale, logoY + 5 * scale, logoSize - 10 * scale, logoSize - 10 * scale);
                    drawContent();
                  };
                  logoImg.onerror = () => {
                    ctx.fillStyle = 'white';
                    ctx.font = `${20 * scale}px Arial`;
                    ctx.textAlign = 'center';
                    ctx.fillText('🏫', logoX + logoSize/2, logoY + logoSize/2 + 7 * scale);
                    drawContent();
                  };
                  
                  // School info
                  ctx.fillStyle = '#1e40af';
                  ctx.font = `bold ${16 * scale}px Arial`;
                  ctx.textAlign = 'left';
                  ctx.fillText(schoolSettings.name, logoX + logoSize + 10 * scale, logoY + 16 * scale);
                  
                  ctx.fillStyle = '#64748b';
                  ctx.font = `${8 * scale}px Arial`;
                  ctx.fillText(schoolSettings.address, logoX + logoSize + 10 * scale, logoY + 28 * scale);
                  ctx.fillText(`📞 ${schoolSettings.phone}`, logoX + logoSize + 10 * scale, logoY + 38 * scale);
                  
                  // Year badge
                  const badgeWidth = 60 * scale;
                  const badgeHeight = 24 * scale;
                  const badgeX = canvas.width - badgeWidth - 15 * scale;
                  const badgeY = 20 * scale;
                  ctx.fillStyle = '#dc2626';
                  ctx.beginPath();
                  ctx.roundRect(badgeX, badgeY, badgeWidth, badgeHeight, 4 * scale);
                  ctx.fill();
                  
                  ctx.fillStyle = 'white';
                  ctx.font = `bold ${10 * scale}px Arial`;
                  ctx.textAlign = 'center';
                  ctx.fillText('2025-26', badgeX + badgeWidth/2, badgeY + 16 * scale);
                  
                  const drawContent = () => {
                    // Photo area
                    const photoX = 15 * scale;
                    const photoY = headerHeight + 15 * scale;
                    const photoWidth = 70 * scale;
                    const photoHeight = 85 * scale;
                    
                    ctx.fillStyle = '#f3f4f6';
                    ctx.beginPath();
                    ctx.roundRect(photoX, photoY, photoWidth, photoHeight, 6 * scale);
                    ctx.fill();
                    
                    ctx.strokeStyle = '#ffffff';
                    ctx.lineWidth = 6;
                    ctx.beginPath();
                    ctx.roundRect(photoX, photoY, photoWidth, photoHeight, 6 * scale);
                    ctx.stroke();
                    
                    const drawPhoto = () => {
                      if (selectedStudent?.profilePicture) {
                        const img = new Image();
                        img.crossOrigin = 'anonymous';
                        img.onload = () => {
                          ctx.save();
                          ctx.beginPath();
                          ctx.roundRect(photoX + 3, photoY + 3, photoWidth - 6, photoHeight - 6, 6 * scale);
                          ctx.clip();
                          
                          const imgAspect = img.width / img.height;
                          const frameAspect = (photoWidth - 6) / (photoHeight - 6);
                          
                          let drawWidth, drawHeight, drawX, drawY;
                          
                          if (imgAspect > frameAspect) {
                            drawHeight = photoHeight - 6;
                            drawWidth = drawHeight * imgAspect;
                            drawX = photoX + 3 - (drawWidth - (photoWidth - 6)) / 2;
                            drawY = photoY + 3;
                          } else {
                            drawWidth = photoWidth - 6;
                            drawHeight = drawWidth / imgAspect;
                            drawX = photoX + 3;
                            drawY = photoY + 3 - (drawHeight - (photoHeight - 6)) / 2;
                          }
                          
                          ctx.drawImage(img, drawX, drawY, drawWidth, drawHeight);
                          ctx.restore();
                          
                          // Download after photo is drawn
                          setTimeout(() => {
                            const link = document.createElement('a');
                            link.download = `${selectedStudent?.name || idCardData.name}_School_ID_Card.png`;
                            link.href = canvas.toDataURL('image/png', 1.0);
                            link.click();
                          }, 100);
                        };
                        img.onerror = () => {
                          ctx.fillStyle = '#6b7280';
                          ctx.font = `${24 * scale}px Arial`;
                          ctx.textAlign = 'center';
                          ctx.fillText('👤', photoX + photoWidth/2, photoY + photoHeight/2 + 8 * scale);
                          
                          // Download with fallback icon
                          setTimeout(() => {
                            const link = document.createElement('a');
                            link.download = `${selectedStudent?.name || idCardData.name}_School_ID_Card.png`;
                            link.href = canvas.toDataURL('image/png', 1.0);
                            link.click();
                          }, 100);
                        };
                        img.src = `${API_BASE_URL}${selectedStudent.profilePicture}`;
                      } else {
                        ctx.fillStyle = '#6b7280';
                        ctx.font = `${24 * scale}px Arial`;
                        ctx.textAlign = 'center';
                        ctx.fillText('👤', photoX + photoWidth/2, photoY + photoHeight/2 + 8 * scale);
                        
                        // Download with fallback icon
                        setTimeout(() => {
                          const link = document.createElement('a');
                          link.download = `${selectedStudent?.name || idCardData.name}_School_ID_Card.png`;
                          link.href = canvas.toDataURL('image/png', 1.0);
                          link.click();
                        }, 100);
                      }
                    };
                    
                    drawPhoto();
                    
                    // ID badge
                    const idBadgeY = photoY + photoHeight + 8 * scale;
                    const idBadgeWidth = 70 * scale;
                    const idBadgeHeight = 18 * scale;
                    ctx.fillStyle = '#ffffff';
                    ctx.beginPath();
                    ctx.roundRect(photoX, idBadgeY, idBadgeWidth, idBadgeHeight, 4 * scale);
                    ctx.fill();
                    
                    ctx.fillStyle = '#1e40af';
                    ctx.font = `bold ${9 * scale}px Arial`;
                    ctx.textAlign = 'center';
                    ctx.fillText(`ID: ${idCardData.scholarNo || selectedStudent._id?.slice(-6)}`, photoX + idBadgeWidth/2, idBadgeY + 12 * scale);
                    
                    // Student info
                    const infoX = photoX + photoWidth + 15 * scale;
                    const infoY = photoY;
                    
                    ctx.fillStyle = 'white';
                    ctx.textAlign = 'left';
                    ctx.font = `bold ${14 * scale}px Arial`;
                    ctx.fillText(selectedStudent?.name || idCardData.name, infoX, infoY + 20 * scale);
                    
                    ctx.font = `${11 * scale}px Arial`;
                    ctx.fillStyle = 'rgba(255,255,255,0.9)';
                    ctx.fillText(`Class: ${idCardData.class || selectedStudent.class}`, infoX, infoY + 35 * scale);
                    
                    // Details
                    ctx.font = `${10 * scale}px Arial`;
                    ctx.fillStyle = 'rgba(255,255,255,0.95)';
                    let detailY = infoY + 55 * scale;
                    const lineHeight = 12 * scale;
                    
                    ctx.fillText(`DOB: ${idCardData.dob ? new Date(idCardData.dob).toLocaleDateString('en-GB') : 'N/A'}`, infoX, detailY);
                    detailY += lineHeight;
                    
                    const fatherName = (idCardData.fathersName || 'N/A');
                    const displayFatherName = fatherName.length > 15 ? fatherName.substring(0, 15) + '...' : fatherName;
                    ctx.fillText(`Father: ${displayFatherName}`, infoX, detailY);
                    detailY += lineHeight;
                    
                    ctx.fillText(`Mobile: ${idCardData.mobile || 'N/A'}`, infoX, detailY);
                    detailY += lineHeight;
                    
                    const address = (idCardData.address || 'N/A');
                    const displayAddress = address.length > 20 ? address.substring(0, 20) + '...' : address;
                    ctx.fillText(`Address: ${displayAddress}`, infoX, detailY);
                    
                    // Validity
                    const validityX = canvas.width - 90 * scale;
                    const validityY = canvas.height - 40 * scale;
                    ctx.fillStyle = 'rgba(255,255,255,0.2)';
                    ctx.beginPath();
                    ctx.roundRect(validityX, validityY, 75 * scale, 30 * scale, 4 * scale);
                    ctx.fill();
                    
                    ctx.fillStyle = 'white';
                    ctx.font = `${8 * scale}px Arial`;
                    ctx.textAlign = 'center';
                    ctx.fillText('Valid Until', validityX + 37.5 * scale, validityY + 12 * scale);
                    ctx.fillText('March 2026', validityX + 37.5 * scale, validityY + 22 * scale);
                  };
                  
                  logoImg.src = '/logo.png';
                }}
                style={{ 
                  background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)', 
                  color: 'white', 
                  border: 'none', 
                  padding: '10px 20px', 
                  borderRadius: '8px', 
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: 'bold'
                }}
              >
                💾 Download ID Card
              </button>
              {(user.name === 'admin1' || user.email === 'a1@s.com' || user.role === 'admin1') && (
                <button 
                  onClick={() => {
                    const newName = prompt('School Name:', localStorage.getItem('schoolName') || 'The Rising School');
                    const newAddress = prompt('School Address:', localStorage.getItem('schoolAddress') || 'Savina, Udaipur');
                    const newPhone = prompt('School Phone:', localStorage.getItem('schoolPhone') || '8209683549');
                    
                    if (newName !== null) localStorage.setItem('schoolName', newName || 'The Rising School');
                    if (newAddress !== null) localStorage.setItem('schoolAddress', newAddress || 'Savina, Udaipur');
                    if (newPhone !== null) localStorage.setItem('schoolPhone', newPhone || '8209683549');
                    
                    alert('School settings updated! Changes will reflect in all ID cards.');
                    window.location.reload();
                  }}
                  style={{ 
                    background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', 
                    color: 'white', 
                    border: 'none', 
                    padding: '10px 20px', 
                    borderRadius: '8px', 
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: 'bold'
                  }}
                >
                  ⚙️ School Settings
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {showClassworkModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.6)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 5000 }}>
          <div style={{ background: 'white', borderRadius: '15px', width: '90%', maxWidth: '500px', padding: '25px', boxShadow: '0 20px 40px rgba(0,0,0,0.3)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h2 style={{ margin: 0, color: '#333', fontSize: '22px', fontWeight: 'bold' }}>📅 Daily Classwork & Homework</h2>
              <button 
                onClick={() => setShowClassworkModal(false)} 
                style={{ 
                  background: '#dc2626', 
                  color: 'white', 
                  border: 'none', 
                  padding: '8px 12px', 
                  borderRadius: '50%', 
                  cursor: 'pointer',
                  fontSize: '16px'
                }}
              >
                ✕
              </button>
            </div>
            
            <form onSubmit={handleClassworkSubmit}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '15px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>📅 Date:</label>
                  <input
                    type="date"
                    value={newClasswork.date}
                    onChange={(e) => setNewClasswork({...newClasswork, date: e.target.value})}
                    required
                    style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>📝 Type:</label>
                  <select
                    value={newClasswork.type}
                    onChange={(e) => setNewClasswork({...newClasswork, type: e.target.value})}
                    style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }}
                  >
                    <option value="classwork">  Classwork</option>
                    <option value="homework">📝 Homework</option>
                  </select>
                </div>
              </div>
              
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>📖 Subject:</label>
                <select
                  value={newClasswork.subject}
                  onChange={(e) => setNewClasswork({...newClasswork, subject: e.target.value})}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }}
                >
                  {dynamicSubjects.map(subject => (
                    <option key={subject} value={subject}>{subject}</option>
                  ))}
                </select>
              </div>
              
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>💬 Message:</label>
                <textarea
                  value={newClasswork.message}
                  onChange={(e) => setNewClasswork({...newClasswork, message: e.target.value})}
                  placeholder="Enter classwork or homework details..."
                  required
                  rows="4"
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px', resize: 'vertical' }}
                />
              </div>
              
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                <button 
                  type="button"
                  onClick={() => setShowClassworkModal(false)}
                  style={{ 
                    background: '#6c757d', 
                    color: 'white', 
                    border: 'none', 
                    padding: '10px 20px', 
                    borderRadius: '5px', 
                    cursor: 'pointer'
                  }}
                >
                  Cancel
                </button>
                <button 
                  type="submit"
                  style={{ 
                    background: 'linear-gradient(45deg, #28a745, #20c997)', 
                    color: 'white', 
                    border: 'none', 
                    padding: '10px 20px', 
                    borderRadius: '5px', 
                    cursor: 'pointer',
                    fontWeight: 'bold'
                  }}
                >
                  📤 Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showTemplateManager && (
        <MarksheetTemplateManager onClose={() => setShowTemplateManager(false)} />
      )}

      {showTemplateBasedMarksheet && selectedStudent && (
        <TemplateBasedMarksheetEntry 
          student={selectedStudent}
          onClose={() => {
            setShowTemplateBasedMarksheet(false);
            setSelectedStudent(null);
          }}
          onSave={() => {
            // Refresh any necessary data after saving
            console.log('Marksheet saved successfully');
          }}
        />
      )}

      {showWhatsAppMessenger && selectedStudentForWhatsApp && (
        <WhatsAppMessenger 
          student={selectedStudentForWhatsApp}
          onClose={() => {
            setShowWhatsAppMessenger(false);
            setSelectedStudentForWhatsApp(null);
          }}
        />
      )}

      {showDiaryPopup && (
        <EnhancedTeacherDiary 
          userClass={user.class}
          userName={user.name}
          onClose={() => setShowDiaryPopup(false)}
          isFullView={true}
        />
      )}

      {showDeviceMonitor && (
        <StudentDeviceMonitor 
          userRole="teacher"
          userClass={user.class}
          onClose={() => setShowDeviceMonitor(false)}
        />
      )}

      {showDailyAttendance && selectedAttendanceDate && (
        <DailyAttendanceView 
          selectedDate={selectedAttendanceDate}
          userClass={user.class}
          onClose={() => {
            setShowDailyAttendance(false);
            setSelectedAttendanceDate(null);
          }}
        />
      )}

      {showEnhancedAttendanceView && (
        <EnhancedTeacherAttendanceView 
          teacherId={user.id}
          teacherName={user.name}
          userRole={user.role}
          onClose={() => setShowEnhancedAttendanceView(false)}
        />
      )}

      {showTimetableManager && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(0,0,0,0.5)',
          zIndex: 10000,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '20px'
        }}>
          <div style={{
            background: 'white',
            borderRadius: '10px',
            width: '95%',
            maxWidth: '1200px',
            height: '90%',
            overflow: 'auto',
            position: 'relative'
          }}>
            <button
              onClick={() => setShowTimetableManager(false)}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                background: '#dc3545',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '30px',
                height: '30px',
                cursor: 'pointer',
                zIndex: 10001
              }}
            >
              ×
            </button>
            <TimetableManager 
              userRole="teacher" 
              userId={user.id} 
              userName={user.name} 
            />
          </div>
        </div>
      )}

      {showIdCard && selectedStudent && idCardData && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 5000, padding: '20px' }}>
          <div style={{ background: 'white', borderRadius: '15px', padding: '20px', boxShadow: '0 20px 40px rgba(0,0,0,0.3)', display: 'flex', flexDirection: 'column', alignItems: 'center', width: '90%', maxWidth: '500px', margin: '0 auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', width: '100%' }}>
              <h2 style={{ margin: 0, color: '#10b981', fontSize: '20px', fontWeight: 'bold' }}>🆔 Student ID Card - {selectedStudent.name}</h2>
              <button 
                onClick={() => setShowIdCard(false)} 
                style={{ 
                  background: '#dc2626', 
                  color: 'white', 
                  border: 'none', 
                  padding: '8px 12px', 
                  borderRadius: '50%', 
                  cursor: 'pointer',
                  fontSize: '16px'
                }}
              >
                ×
              </button>
            </div>
            
            <div data-id-card style={{ 
              width: '100%', 
              maxWidth: '350px', 
              height: '220px', 
              background: '#1e40af',
              borderRadius: '10px', 
              padding: '0',
              boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
              border: '2px solid #ffffff',
              position: 'relative',
              overflow: 'hidden',
              marginBottom: '20px'
            }}>
              {/* Header section */}
              <div style={{ 
                background: '#ffffff', 
                padding: '12px 15px', 
                borderRadius: '8px 8px 0 0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{
                    width: '40px',
                    height: '40px',
                    background: '#1e40af',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '20px',
                    color: 'white'
                  }}>
                    <img 
                      src="/logo.png" 
                      alt="School Logo" 
                      style={{
                        width: '30px',
                        height: '30px',
                        objectFit: 'contain'
                      }}
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.parentElement.innerHTML = '🏢';
                      }}
                    />
                  </div>
                  <div>
                    <h3 style={{ color: '#1e40af', margin: '0', fontSize: '20px', fontWeight: 'bold' }}>{localStorage.getItem('schoolName') || 'The Rising School'}</h3>
                    <p style={{ margin: '0', fontSize: '12px', color: '#64748b' }}>{localStorage.getItem('schoolAddress') || 'Savina, Udaipur'}</p>
                    <p style={{ margin: '0', fontSize: '12px', color: '#64748b' }}>📞 {localStorage.getItem('schoolPhone') || '8209683549'}</p>
                  </div>
                </div>
                <div style={{
                  background: '#dc2626',
                  color: 'white',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  fontSize: '10px',
                  fontWeight: 'bold'
                }}>2025-26</div>
              </div>
              
              {/* Main content */}
              <div style={{ padding: '15px', display: 'flex', gap: '15px', height: 'calc(100% - 64px)' }}>
                {/* Photo section */}
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <div style={{
                    width: '70px',
                    height: '85px',
                    background: selectedStudent?.profilePicture 
                      ? `url(${selectedStudent.profilePicture}) center/cover no-repeat` 
                      : '#f3f4f6',
                    border: '2px solid #ffffff',
                    borderRadius: '6px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px',
                    color: '#6b7280',
                    overflow: 'hidden'
                  }}>
                    {!selectedStudent?.profilePicture && '👤'}
                  </div>
                  <div style={{
                    marginTop: '8px',
                    background: '#ffffff',
                    padding: '3px 8px',
                    borderRadius: '4px',
                    fontSize: '9px',
                    fontWeight: 'bold',
                    color: '#1e40af'
                  }}>SR.No.: {idCardData.scholarNo || selectedStudent._id?.slice(-6)}</div>
                </div>
                
                {/* Info section */}
                <div style={{ flex: 1, color: 'white' }}>
                  <div style={{ marginBottom: '10px' }}>
                    <h4 style={{ 
                      margin: '0 0 2px 0', 
                      fontSize: '16px', 
                      fontWeight: 'bold', 
                      color: 'white'
                    }}>{selectedStudent.name}</h4>
                    <p style={{ 
                      margin: '0', 
                      fontSize: '12px', 
                      color: 'rgba(255,255,255,0.9)'
                    }}>Class: {selectedStudent.class}</p>
                  </div>
                  
                  <div style={{ fontSize: '11px', lineHeight: '1.6', color: 'rgba(255,255,255,0.95)' }}>
                    <div style={{ marginBottom: '4px' }}>
                      <span style={{ fontWeight: 'bold' }}>DOB: </span>
                      <span>{idCardData.dob ? new Date(idCardData.dob).toLocaleDateString('en-GB') : 'N/A'}</span>
                    </div>
                    <div style={{ marginBottom: '4px' }}>
                      <span style={{ fontWeight: 'bold' }}>Father: </span>
                      <span>{(idCardData.fathersName || 'N/A').length > 15 ? (idCardData.fathersName || 'N/A').substring(0, 15) + '...' : (idCardData.fathersName || 'N/A')}</span>
                    </div>
                    <div style={{ marginBottom: '4px' }}>
                      <span style={{ fontWeight: 'bold' }}>Mobile: </span>
                      <span>{idCardData.mobile || 'N/A'}</span>
                    </div>
                    <div>
                      <span style={{ fontWeight: 'bold' }}>Address: </span>
                      <span>{(idCardData.address || 'N/A').length > 20 ? (idCardData.address || 'N/A').substring(0, 20) + '...' : (idCardData.address || 'N/A')}</span>
                    </div>
                  </div>
                  
                  {/* Validity section */}
                  <div style={{
                    position: 'absolute',
                    bottom: '10px',
                    right: '15px',
                    background: 'rgba(255,255,255,0.2)',
                    padding: '4px 8px',
                    borderRadius: '4px'
                  }}>
                    <div style={{ fontSize: '8px', color: 'white', textAlign: 'center' }}>
                      <div>Valid Until</div>
                      <div>March 2026</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '20px', flexWrap: 'wrap' }}>
              <button 
                onClick={() => {
                  // Download ID card functionality for teachers
                  const canvas = document.createElement('canvas');
                  const ctx = canvas.getContext('2d');
                  
                  // Simple dimensions matching display (350x220 scaled up)
                  canvas.width = 1050; // 350 * 3
                  canvas.height = 660;  // 220 * 3
                  const scale = 3;
                  
                  // School settings
                  const schoolSettings = {
                    name: localStorage.getItem('schoolName') || 'The Rising School',
                    address: localStorage.getItem('schoolAddress') || 'Savina, Udaipur',
                    phone: localStorage.getItem('schoolPhone') || '8209683549'
                  };
                  
                  // Main blue background
                  ctx.fillStyle = '#1e40af';
                  ctx.fillRect(0, 0, canvas.width, canvas.height);
                  
                  // Rounded corners
                  ctx.globalCompositeOperation = 'destination-in';
                  ctx.beginPath();
                  ctx.roundRect(0, 0, canvas.width, canvas.height, 10 * scale);
                  ctx.fill();
                  ctx.globalCompositeOperation = 'source-over';
                  
                  // White border
                  ctx.strokeStyle = '#ffffff';
                  ctx.lineWidth = 6;
                  ctx.beginPath();
                  ctx.roundRect(3, 3, canvas.width-6, canvas.height-6, 7 * scale);
                  ctx.stroke();
                  
                  // Header section
                  const headerHeight = 64 * scale;
                  ctx.fillStyle = '#ffffff';
                  ctx.beginPath();
                  ctx.roundRect(0, 0, canvas.width, headerHeight, [8 * scale, 8 * scale, 0, 0]);
                  ctx.fill();
                  
                  // Logo area
                  const logoSize = 40 * scale;
                  const logoX = 15 * scale;
                  const logoY = 12 * scale;
                  ctx.fillStyle = '#1e40af';
                  ctx.beginPath();
                  ctx.roundRect(logoX, logoY, logoSize, logoSize, 8 * scale);
                  ctx.fill();
                  
                  // Try to load logo
                  const logoImg = new Image();
                  logoImg.crossOrigin = 'anonymous';
                  logoImg.onload = () => {
                    ctx.drawImage(logoImg, logoX + 5 * scale, logoY + 5 * scale, logoSize - 10 * scale, logoSize - 10 * scale);
                    drawContent();
                  };
                  logoImg.onerror = () => {
                    ctx.fillStyle = 'white';
                    ctx.font = `${20 * scale}px Arial`;
                    ctx.textAlign = 'center';
                    ctx.fillText('🏢', logoX + logoSize/2, logoY + logoSize/2 + 7 * scale);
                    drawContent();
                  };
                  
                  // School info
                  ctx.fillStyle = '#1e40af';
                  ctx.font = `bold ${16 * scale}px Arial`;
                  ctx.textAlign = 'left';
                  ctx.fillText(schoolSettings.name, logoX + logoSize + 10 * scale, logoY + 16 * scale);
                  
                  ctx.fillStyle = '#64748b';
                  ctx.font = `${8 * scale}px Arial`;
                  ctx.fillText(schoolSettings.address, logoX + logoSize + 10 * scale, logoY + 28 * scale);
                  ctx.fillText(`📞 ${schoolSettings.phone}`, logoX + logoSize + 10 * scale, logoY + 38 * scale);
                  
                  // Year badge
                  const badgeWidth = 60 * scale;
                  const badgeHeight = 24 * scale;
                  const badgeX = canvas.width - badgeWidth - 15 * scale;
                  const badgeY = 20 * scale;
                  ctx.fillStyle = '#dc2626';
                  ctx.beginPath();
                  ctx.roundRect(badgeX, badgeY, badgeWidth, badgeHeight, 4 * scale);
                  ctx.fill();
                  
                  ctx.fillStyle = 'white';
                  ctx.font = `bold ${10 * scale}px Arial`;
                  ctx.textAlign = 'center';
                  ctx.fillText('2025-26', badgeX + badgeWidth/2, badgeY + 16 * scale);
                  
                  const drawContent = () => {
                    // Photo area
                    const photoX = 15 * scale;
                    const photoY = headerHeight + 15 * scale;
                    const photoWidth = 70 * scale;
                    const photoHeight = 85 * scale;
                    
                    ctx.fillStyle = '#f3f4f6';
                    ctx.beginPath();
                    ctx.roundRect(photoX, photoY, photoWidth, photoHeight, 6 * scale);
                    ctx.fill();
                    
                    ctx.strokeStyle = '#ffffff';
                    ctx.lineWidth = 6;
                    ctx.beginPath();
                    ctx.roundRect(photoX, photoY, photoWidth, photoHeight, 6 * scale);
                    ctx.stroke();
                    
                    const drawPhoto = () => {
                      if (selectedStudent?.profilePicture) {
                        const img = new Image();
                        img.crossOrigin = 'anonymous';
                        img.onload = () => {
                          ctx.save();
                          ctx.beginPath();
                          ctx.roundRect(photoX + 3, photoY + 3, photoWidth - 6, photoHeight - 6, 6 * scale);
                          ctx.clip();
                          
                          const imgAspect = img.width / img.height;
                          const frameAspect = (photoWidth - 6) / (photoHeight - 6);
                          
                          let drawWidth, drawHeight, drawX, drawY;
                          
                          if (imgAspect > frameAspect) {
                            drawHeight = photoHeight - 6;
                            drawWidth = drawHeight * imgAspect;
                            drawX = photoX + 3 - (drawWidth - (photoWidth - 6)) / 2;
                            drawY = photoY + 3;
                          } else {
                            drawWidth = photoWidth - 6;
                            drawHeight = drawWidth / imgAspect;
                            drawX = photoX + 3;
                            drawY = photoY + 3 - (drawHeight - (photoHeight - 6)) / 2;
                          }
                          
                          ctx.drawImage(img, drawX, drawY, drawWidth, drawHeight);
                          ctx.restore();
                          
                          // Download after photo is drawn
                          setTimeout(() => {
                            const link = document.createElement('a');
                            link.download = `${selectedStudent?.name || idCardData.name}_School_ID_Card.png`;
                            link.href = canvas.toDataURL('image/png', 1.0);
                            link.click();
                          }, 100);
                        };
                        img.onerror = () => {
                          ctx.fillStyle = '#6b7280';
                          ctx.font = `${24 * scale}px Arial`;
                          ctx.textAlign = 'center';
                          ctx.fillText('👤', photoX + photoWidth/2, photoY + photoHeight/2 + 8 * scale);
                          
                          // Download with fallback icon
                          setTimeout(() => {
                            const link = document.createElement('a');
                            link.download = `${selectedStudent?.name || idCardData.name}_School_ID_Card.png`;
                            link.href = canvas.toDataURL('image/png', 1.0);
                            link.click();
                          }, 100);
                        };
                        img.src = `${API_BASE_URL}${selectedStudent.profilePicture}`;
                      } else {
                        ctx.fillStyle = '#6b7280';
                        ctx.font = `${24 * scale}px Arial`;
                        ctx.textAlign = 'center';
                        ctx.fillText('👤', photoX + photoWidth/2, photoY + photoHeight/2 + 8 * scale);
                        
                        // Download with fallback icon
                        setTimeout(() => {
                          const link = document.createElement('a');
                          link.download = `${selectedStudent?.name || idCardData.name}_School_ID_Card.png`;
                          link.href = canvas.toDataURL('image/png', 1.0);
                          link.click();
                        }, 100);
                      }
                    };
                    
                    drawPhoto();
                    
                    // ID badge
                    const idBadgeY = photoY + photoHeight + 8 * scale;
                    const idBadgeWidth = 70 * scale;
                    const idBadgeHeight = 18 * scale;
                    ctx.fillStyle = '#ffffff';
                    ctx.beginPath();
                    ctx.roundRect(photoX, idBadgeY, idBadgeWidth, idBadgeHeight, 4 * scale);
                    ctx.fill();
                    
                    ctx.fillStyle = '#1e40af';
                    ctx.font = `bold ${9 * scale}px Arial`;
                    ctx.textAlign = 'center';
                    ctx.fillText(`SR.No.: ${idCardData.scholarNo || selectedStudent._id?.slice(-6)}`, photoX + idBadgeWidth/2, idBadgeY + 12 * scale);
                    
                    // Student info
                    const infoX = photoX + photoWidth + 15 * scale;
                    const infoY = photoY;
                    
                    ctx.fillStyle = 'white';
                    ctx.textAlign = 'left';
                    ctx.font = `bold ${14 * scale}px Arial`;
                    ctx.fillText(selectedStudent?.name || idCardData.name, infoX, infoY + 20 * scale);
                    
                    ctx.font = `${11 * scale}px Arial`;
                    ctx.fillStyle = 'rgba(255,255,255,0.9)';
                    ctx.fillText(`Class: ${idCardData.class || selectedStudent.class}`, infoX, infoY + 35 * scale);
                    
                    // Details
                    ctx.font = `${10 * scale}px Arial`;
                    ctx.fillStyle = 'rgba(255,255,255,0.95)';
                    let detailY = infoY + 55 * scale;
                    const lineHeight = 12 * scale;
                    
                    ctx.fillText(`DOB: ${idCardData.dob ? new Date(idCardData.dob).toLocaleDateString('en-GB') : 'N/A'}`, infoX, detailY);
                    detailY += lineHeight;
                    
                    const fatherName = (idCardData.fathersName || 'N/A');
                    const displayFatherName = fatherName.length > 15 ? fatherName.substring(0, 15) + '...' : fatherName;
                    ctx.fillText(`Father: ${displayFatherName}`, infoX, detailY);
                    detailY += lineHeight;
                    
                    ctx.fillText(`Mobile: ${idCardData.mobile || 'N/A'}`, infoX, detailY);
                    detailY += lineHeight;
                    
                    const address = (idCardData.address || 'N/A');
                    const displayAddress = address.length > 20 ? address.substring(0, 20) + '...' : address;
                    ctx.fillText(`Address: ${displayAddress}`, infoX, detailY);
                    
                    // Validity
                    const validityX = canvas.width - 90 * scale;
                    const validityY = canvas.height - 40 * scale;
                    ctx.fillStyle = 'rgba(255,255,255,0.2)';
                    ctx.beginPath();
                    ctx.roundRect(validityX, validityY, 75 * scale, 30 * scale, 4 * scale);
                    ctx.fill();
                    
                    ctx.fillStyle = 'white';
                    ctx.font = `${8 * scale}px Arial`;
                    ctx.textAlign = 'center';
                    ctx.fillText('Valid Until', validityX + 37.5 * scale, validityY + 12 * scale);
                    ctx.fillText('March 2026', validityX + 37.5 * scale, validityY + 22 * scale);
                  };
                  
                  logoImg.src = '/logo.png';
                }}
                style={{ 
                  background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)', 
                  color: 'white', 
                  border: 'none', 
                  padding: '12px 24px', 
                  borderRadius: '10px', 
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '600',
                  boxShadow: '0 4px 15px rgba(139, 92, 246, 0.3)',
                  transition: 'all 0.3s ease'
                }}
              >
                💾 Download ID Card
              </button>
              {(user.name === 'admin1' || user.email === 'a1@s.com' || user.role === 'admin1') && (
                <button 
                  onClick={() => {
                    const newName = prompt('School Name:', localStorage.getItem('schoolName') || 'The Rising School');
                    const newAddress = prompt('School Address:', localStorage.getItem('schoolAddress') || 'Savina, Udaipur');
                    const newPhone = prompt('School Phone:', localStorage.getItem('schoolPhone') || '8209683549');
                    
                    if (newName !== null) localStorage.setItem('schoolName', newName || 'The Rising School');
                    if (newAddress !== null) localStorage.setItem('schoolAddress', newAddress || 'Savina, Udaipur');
                    if (newPhone !== null) localStorage.setItem('schoolPhone', newPhone || '8209683549');
                    
                    alert('School settings updated! Changes will reflect in all ID cards.');
                    window.location.reload();
                  }}
                  style={{ 
                    background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', 
                    color: 'white', 
                    border: 'none', 
                    padding: '12px 20px', 
                    borderRadius: '10px', 
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '600',
                    boxShadow: '0 4px 15px rgba(245, 158, 11, 0.3)',
                    transition: 'all 0.3s ease'
                  }}
                >
                  ⚙️ School Settings
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {showChangePassword && <ChangePassword user={user} onClose={() => setShowChangePassword(false)} />}
    </TeacherHome>
    </>
  );
}

export default TeacherDashboard;
